<template>
  <div>
    <!-- <div class="page-header">
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" dark class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t("modeldata") }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
    </div> -->
    <v-container fluid>
      <v-overlay
        v-model="showSuccess"
        :scrim="true"
        opacity="0.3"
        persistent
        :z-index="9900"
      >
      </v-overlay>
      <transition name="fade-slide">
        <div v-if="showSuccess" class="success-toast" role="status">
          <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
          <span style="font-size: 15px; font-weight: 600;">{{ successMessage }}</span>
        </div>
      </transition>

      <div class="main-card">
        <div class="action-bar">
          <div>
            <h2 style="font-weight: 600; color: #171717;">LLMs Management</h2>
          </div>
          <div class="d-flex justify-start align-center" style="gap: 10px;">
            <v-text-field
              placeholder="Search Platform, Provider, or Model"
              variant="none"
              density="comfortable"
              hide-details
              class="search-section"
              v-model="searchKeyword"
              @keydown.enter="Search"
            >
              <template #prepend-inner>
                <img
                  class="search-icon"
                  src="@/assets/flowbite_search-outline.svg"
                  alt="Search"
                  width="20"
                  height="20"
                />
              </template>
            </v-text-field>

            <div class="action-divider"></div>
  
            <button type="button"
              id="button-add-modeldata"
              color="grey"
              class="products-header-button"
              variant="elevated"
              @click="Add()"
            >
              <img src="@/assets/ic_round-plus.svg" alt="img" width="20" height="20" />
              <span style="color: #ffffff; font-size: 14px;">Add Model</span>
            </button>
          </div>
        </div>
  
        <div>
          <v-data-table-server
            :items="listDataModel"
            :headers="headers"
            :items-per-page="options.itemsPerPage"
            :items-length="searchTotalTable"
            v-model:options="options"
            class="mt-4"
            :loading="dialog"
            loading-text="Loading models..."
          >
            <template v-slot:bottom>
              <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
                <div>Total results {{ searchTotalTable }}</div>

                <v-data-table-footer
                  :items="[
                    { text: '10', value: 10 },
                    { text: '25', value: 25 },
                    { text: '50', value: 50 },
                    { text: '100', value: 100 },
                    { text: 'All', value: -1 },
                  ]"
                  :page="options.page"
                  :length="Math.ceil(searchTotalTable / itemsPerPage)"
                />
              </div>
            </template>

            <template #no-data>
              <div style="text-align: center;">
                <span style="color: #646464; font-weight: 400;">No Data Available</span>
              </div>
            </template>
            <!-- Custom row template -->
            <template v-slot:item="{ item, index }">
              <tr class="table-row">
                <td style="text-align: left">
                  <div>
                    {{ (options.page - 1) * itemsPerPage + (index + 1) }}
                  </div>
                </td>
                <td style="text-align: left">
                  <span class="provider-name">{{ item.platform || "-" }}</span>
                </td>
                <td style="text-align: left">
                  <span class="provider-name">{{ item.provider }}</span>
                </td>
                <td style="text-align: left">
                    <span class="provider-name">{{ item.modelDisplay }}</span>
                </td>
                <td style="text-align: left">
                  <code class="provider-name">{{ item.modelName }}</code>
                </td>
                <td style="text-align: left">
                  <span class="provider-name">{{ item.apiVersion || "-" }}</span>
                </td>
                <td class="text-center">
                  <div
                    class="model-type-badge"
                    :class="getModelTypeClass(item.modelType)"
                  >
                    <img :src="item.modelType === 'text_based' ? textModelTypeIcon : imageModelTypeIcon" alt="img" width="14" height="14" />
                    <!-- <v-icon>
                      {{
                        item.modelType === "text_based" ? "mdi-text" : "mdi-image"
                      }}
                    </v-icon> -->
                    <span style="font-size: 12px">
                      {{
                        item.modelType === "text_based"
                          ? "Text-Based"
                          : "Text-to-Image"
                      }}
                    </span>
                  </div>
                </td>
                <td style="text-align: center">
                  <div class="price-display">
                    <template v-if="item.modelType === 'text_based'">
                      <div class="price-row">
                        <v-tooltip location="top" max-width="400px">
                          <template v-slot:activator="{ props }">
                            <div class="price-item input" v-bind="props">
                              <v-icon size="12" color="success"
                                >mdi-arrow-down</v-icon
                              >
                              <span style="color: #2ABF56;">{{ item.promptPriceUSD }}</span>
                            </div>
                          </template>
                          <span>Input Price</span>
                        </v-tooltip>

                        <v-tooltip location="top" max-width="400px">
                          <template v-slot:activator="{ props }">
                            <div class="price-item output" v-bind="props">
                              <v-icon size="12" color="info">mdi-arrow-up</v-icon>
                              <span style="color: #3859D0;">{{ item.completionPriceUSD }}</span>
                            </div>
                          </template>
                          <span>Output Price</span>
                        </v-tooltip>
                      </div>
                      <div class="price-unit">per 1K tokens</div>
                    </template>
                    <template v-else>
                      <div class="price-row">
                        <v-tooltip location="top" max-width="400px">
                          <template v-slot:activator="{ props }">
                            <div class="price-item image" v-bind="props">
                              <img src="@/assets/fi-rr-picture-green.svg" alt="img" width="18" height="18" />
                              <span style="color: #2ABF56;">{{ item.imagePriceUSD }}</span>
                            </div>
                          </template>
                          <span>image output price</span>
                        </v-tooltip>
                      </div>
                      <div class="price-unit">per image</div>
                    </template>
                  </div>
                </td>
                <td style="text-align: left">
                  <div class="action-group" style="justify-content: center">
                    <!-- Edit -->
                     <button
                        type="button"
                        id="button-edit-modeldata" 
                        variant="text"
                        density="comfortable"
                        @click="Edit(item)"
                        icon
                      >
                        <v-tooltip location="top" max-width="230px">
                          <template v-slot:activator="{ props }">
                            <img
                              v-bind="props"
                              src="@/assets/Edit.svg"
                              alt="img"
                              width="20"
                              height="20"
                              style="cursor: pointer; margin-left: 4px;"
                            />
                          </template>
                          <span>Edit</span>
                        </v-tooltip>
                      </button>
  
                    <!-- Delete -->
                     <button
                        type="button"
                        id="button-delete-modeldata"
                        variant="text"
                        density="comfortable"
                        @click="openDeleteDialog(item)"
                      >
                        <v-tooltip location="top" max-width="230px">
                          <template v-slot:activator="{ props }">
                            <img
                              v-bind="props"
                              src="@/assets/Group.svg"
                              alt="img"
                              width="20"
                              height="17"
                              style="cursor: pointer; margin-left: 4px;"
                            />
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                      </button>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table-server>
        </div>
      </div>
    </v-container>

    <!-- Model Add Dialog -->
    <v-dialog v-model="AdddialogUser" max-width="1000px" persistent>
      <v-card>
        <!-- Dialog Header -->
        <div class="header-text-content">
          <h2 class="dialog-header-title"> {{ "Add New Model" }} </h2>
          <p class="dialog-text">{{ "Add a new LLM configuration to make it available for use in your chat workflows" }}</p>
        </div>
        <div>
          <hr>
        </div>

        <!-- Dialog Content -->
        <div class="dialog-body">
          <v-form ref="addForm" v-model="formValid">
            <!-- Basic Information -->
            <div class="form-section">
              <div class="d-flex align-center flex-start gap-2">
                <img src="@/assets/streamline-block_basic-ui-link.svg" alt="img" width="18" height="18" />
                <span class="section-title">Basic Information</span>
              </div>
              <v-row class="mt-2" dense>
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="">Platform</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The hosting platform or API gateway used to access the AI model.</span>
                    </v-tooltip>
                  </div>
                  <v-autocomplete
                    id="add-field-platform-modeldata"
                    v-model="currentPlatform"
                    :items="platformOptions"
                    item-title="text"
                    item-value="value"
                    placeholder="Select Platform"
                    persistent-placeholder
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    @update:model-value="changePlatform"
                    class="model-input-control mt-1"
                    clearable
                  >
                  </v-autocomplete>
                </v-col>

                <!-- Model Provider -->
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="">Model Provider</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The organization or company that created the AI model.</span>
                    </v-tooltip>
                  </div>
                  <v-autocomplete
                    id="add-field-provider-modeldata"
                    v-model="currentProvider"
                    :items="filteredProviderOptions"
                    item-title="providerName"
                    item-value="providerName"
                    placeholder="Select Model Provider"
                    persistent-placeholder
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    :disabled="isModelProviderAutoFilled"
                    @update:model-value="changeProvider"
                    class="model-input-control mt-1"
                    clearable
                  >
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center justify-start gap-2">
                    <label for="">Model Type</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The classification of the model based on its primary function and output capability.</span>
                    </v-tooltip>
                  </div>
                  <v-autocomplete
                    id="add-field-modeltype-modeldata"
                    v-model="currentModelType"
                    :items="modelTypes"
                    item-title="typeName"
                    item-value="typeValue"
                    placeholder="Select Model Type"
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    class="model-input-control mt-1"
                    clearable
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </div>
            <div class="mt-6">
              <hr>
            </div>

            <!-- Model Details -->
            <div class="form-section mt-6">
              <div class="d-flex align-center flex-start gap-2">
                <img src="@/assets/config.svg" alt="img" width="18" height="18" />
                <span class="section-title">Model Configuration</span>
              </div>
              <v-row class="mt-2" dense>
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Display Name">Display Name</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>Enter the name that will be visible to users in the application interface.</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="add-field-displayname-modeldata"
                    v-model="currentModelDisplay"
                    placeholder="Enter Display Name"
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    class="model-input-control mt-1"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Model Name">Model Name</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The technical name used by the model provider to refer to this specific AI version.</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="add-field-modelname-modeldata"
                    v-model="currentModelName"
                    placeholder="Enter Model Name"
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    class="model-input-control mt-1"
                  >
                  </v-text-field>
                </v-col>

                <v-col v-if="showApiVersionField" cols="12" sm="12" md="6" class="mt-2">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="API Version">API Version</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The specific release number or date of the Provider's API.</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="add-field-currentAPIversion-modeldata"
                    v-model="currentAPIVesion"
                    placeholder="eg.,2025-06-12"
                    variant="none"
                    density="comfortable"
                    class="model-input-control mt-1"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="6" class="mt-2">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Max Token">Max Token</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>Set the upper limit on the size of the AI model's response, measured in tokens.</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="add-field-maxToken-modeldata"
                    v-model="maxToken"
                    placeholder="1"
                    variant="none"
                    density="comfortable"
                    class="model-input-control mt-1 model-number-spinner"
                    type="number"
                    min="0"
                    @keydown="preventNegative"
                  >
                    <template #append-inner>
                      <div class="number-arrows">
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="adjustMaxToken(1)"
                        >
                          <img src="@/assets/number-up.svg" alt="up" width="10" height="10" />
                        </v-btn>
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="adjustMaxToken(-1)"
                        >
                          <img src="@/assets/number-down.svg" alt="down" width="10" height="10" />
                        </v-btn>
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <div class="mt-6">
                <hr>
              </div>

              <!-- Additional fields for Other platform -->
              <div v-if="currentPlatform === 'Other'" class="d-flex align-center flex-start gap-2 mt-4">
                <img src="@/assets/icon-park-outline_endpoint-displacement.svg" alt="img" width="18" height="18" />
                <span class="section-title">Endpoint URL</span>
              </div>
              <v-row v-if="currentPlatform === 'Other'" class="mt-1" dense>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Endpoint URL">Endpoint URL</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The target URL used to send and receive data from your custom API or external server.</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="add-field-endpointURL-modeldata"
                    v-model="EndPointURL"
                    placeholder="Endpoint URL"
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    class="model-input-control mt-1"
                  >
                  </v-text-field>
                </v-col>

                <!-- Authentication Header Name -->
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Authentication Header Name">Authentication Header Name</label>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The header field name where the API key or token is stored for security verification during the request.</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="add-field-authen-header-modeldata"
                    v-model="AuthenHeaderName"
                    placeholder="Authentication Header Name"
                    variant="none"
                    density="comfortable"
                    :rules="
                      currentPlatform == 'Other'
                        ? rules.required
                        : rules.notRequired
                    "
                    :disabled="currentPlatform != 'Other'"
                    class="model-input-control mt-1"
                  >
                  </v-text-field>
                </v-col>

                <!-- API Key -->
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="API Key">API Key</label>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The secret authentication token required by the service provider to verify your identity and authorize data processing.</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="add-field-APIkey-modeldata"
                    v-model="API_Key"
                    placeholder="API Key"
                    variant="none"
                    density="comfortable"
                    :type="Show_API_Key ? 'text' : 'password'"
                    :rules="
                      currentPlatform == 'Other'
                        ? rules.required
                        : rules.notRequired
                    "
                    class="model-input-control mt-1"
                  >
                    <template v-slot:append-inner>
                      <v-btn
                        variant="text"
                        @click="Show_API_Key = !Show_API_Key"
                      >
                        <img :src="Show_API_Key ? eyeOn : eyeOff" alt="img" width="20" height="20" />
                      </v-btn>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="mt-4">
                  <hr>
                </v-col>
              </v-row>
            </div>

            <!-- Pricing Configuration -->
            <div class="form-section mt-4">
              <div class="d-flex align-center flex-start gap-2">
                <img src="@/assets/money-dollar-circle-line-red.svg" alt="img" width="20" height="20" />
                <span class="section-title">Pricing Configuration</span>
              </div>
              <v-row class="mt-2" dense v-if="currentModelType !== 'text_to_image'">
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Input Price">Input Price</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The price per token for sending the prompt data to the model.</span>
                    </v-tooltip>
                  </div>
                    <v-text-field
                      id="add-field-InputPrice-modeldata"
                      v-model="CurrentPromptPrice"
                      placeholder="0.000000 per 1K tokens"
                      variant="none"
                      density="comfortable"
                      type="number"
                      step="1"
                      class="model-input-control mt-1 model-number-spinner"
                      :rules="rules.requiredNumber"
                      :error-messages="errorMessage.CurrentPromptPrice.message"
                      :error="errorMessage.CurrentPromptPrice.error"
                    >
                      <template #append-inner>
                        <div class="number-arrows">
                          <v-btn
                            variant="text"
                            size="x-small"
                            @click.stop="adjustPromptPrice(1)"
                          >
                            <img src="@/assets/number-up.svg" alt="img" width="10" height="10" />
                          </v-btn>
                          <v-btn
                            variant="text"
                            size="x-small"
                            @click.stop="adjustPromptPrice(-1)"
                          >
                            <img src="@/assets/number-down.svg" alt="img" width="10" height="10" />
                          </v-btn>
                        </div>
                      </template>
                    </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Output Price">Output Price</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The price per token for the response generated by the model.</span>
                    </v-tooltip>
                  </div>
                    <v-text-field
                      id="add-field-outputprice-modeldata"
                      v-model="CurrentCompletionPrice"
                      placeholder="0.000000 per 1K tokens"
                      variant="none"
                      density="comfortable"
                      type="number"
                      step="1"
                      class="model-input-control mt-1 model-number-spinner"
                      :rules="rules.requiredNumber"
                      :error-messages="errorMessage.CurrentCompletionPrice.message"
                      :error="errorMessage.CurrentCompletionPrice.error"
                    >
                      <template #append-inner>
                        <div class="number-arrows">
                          <v-btn
                            type="button"
                            variant="text"
                            size="x-small"
                            @click.stop="adjustOutputPrice(1)"
                          >
                            <img src="@/assets/number-up.svg" alt="up" width="10" height="10" />
                          </v-btn>
                          <v-btn
                            type="button"
                            variant="text"
                            size="x-small"
                            @click.stop="adjustOutputPrice(-1)"
                          >
                            <img src="@/assets/number-down.svg" alt="down" width="10" height="10" />
                          </v-btn>
                        </div>
                      </template>
                    </v-text-field>
                </v-col>
              </v-row>

              <v-row class="mt-2" v-else dense>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    id="add-field-ImagePrice-modeldata"
                    v-model="CurrentImagePrice"
                    placeholder="0.000000 per image"
                    variant="none"
                    density="comfortable"
                    type="number"
                    step="1"
                    class="model-input-control mt-1 model-number-spinner"
                    :rules="rules.requiredNumber"
                  >
                    <template #append-inner>
                      <div class="number-arrows">
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="adjustCurrentImagePrice(1)"
                        >
                          <img src="@/assets/number-up.svg" alt="up" width="10" height="10" />
                        </v-btn>
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="adjustCurrentImagePrice(-1)"
                        >
                          <img src="@/assets/number-down.svg" alt="down" width="10" height="10" />
                        </v-btn>
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <div class="mt-6">
                <hr>
              </div>
            </div>

            <!-- Image Options (for text-to-image models) -->
            <transition name="fade-slide" class="mt-4">
              <div v-if="currentModelType === 'text_to_image'" class="form-section">
                <div class="d-flex align-center flex-start gap-2">
                  <img src="@/assets/Image option.svg" alt="img" width="18" height="18" />
                  <span class="section-title">Image Generation Options</span>
                </div>
                <v-row class="mt-2" dense>
                  <v-col cols="12" sm="12" md="6" class="mt-2">
                    <div class="d-flex align-center flex-start gap-2">
                      <label for="Quality">Quality</label>
                      <span class="text-error">*</span>
                      <v-tooltip location="top" max-width="230px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>Controls the visual standard and resolution level for the image output.</span>
                      </v-tooltip>
                    </div>
                    <v-select
                      id="add-field-imageQuality-modeldata"
                      v-model="currentQuality"
                      :items="imageQualityOptions"
                      item-title="text"
                      item-value="value"
                      placeholder="Quality"
                      variant="none"
                      density="comfortable"
                      :rules="rules.required"
                      class="model-input-control mt-1"
                    >
                    </v-select>
                  </v-col>

                  <v-col cols="12" sm="12" md="6" class="mt-2">
                    <div class="d-flex align-center flex-start gap-2">
                      <label for="Resolution">Resolution</label>
                      <span class="text-error">*</span>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>Defines the image's size and clarity and may be subject to system limits.</span>
                      </v-tooltip>
                    </div>
                    <v-select
                      id="add-field-Resolution-modeldata"
                      v-model="currentResolution"
                      :items="['1024x1024', '1792x1024', '1024x1792']"
                      placeholder="Resolution"
                      variant="none"
                      density="comfortable"
                      :rules="rules.required"
                      class="model-input-control mt-1"
                    >
                    </v-select>
                  </v-col>

                  <v-col cols="12" sm="12" md="6" class="mt-2">
                    <div class="d-flex align-center flex-start gap-2">
                      <label for="ResponseFormat">Response Format</label>
                      <span class="text-error">*</span>
                      <v-tooltip location="top" max-width="230px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>Defines how the model returns image results.</span>
                      </v-tooltip>
                    </div>
                    <v-select
                      id="add-field-imageFormat-modeldata"
                      v-model="currentResFormat"
                      :items="imageFormatOptions"
                      item-title="text"
                      item-value="value"
                      placeholder="Response Format"
                      variant="none"
                      density="comfortable"
                      :rules="rules.required"
                      class="model-input-control mt-1"
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <div class="mt-6">
                  <hr>
                </div>
              </div>
            </transition>

            <!-- Additional Options -->
            <div class="form-section mt-6">
              <div class="d-flex align-center flex-start gap-2">
                <img src="@/assets/material-symbols_page-info.svg" alt="img" width="18" height="18" />
                <span class="section-title">Additional Options</span>
              </div>
              <v-row>
                <v-col cols="12" sm="12" md="6" class="mt-2">
                  <div class="additional-option-group">
                    <div class="d-flex align-center justify-start gap-2 mt-3" >
                      <p class="switch-title">File Upload Support</p>
                      <v-tooltip location="top" max-width="230px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>Toggle to allow file attachments to be submitted as context to the AI model.</span>
                      </v-tooltip>
                    </div>
                    <div class="d-flex align-center justify-space-between">
                      <p style="color: #171717; font-size: 14px;">Allow file uploads with this model</p>
                      <v-switch id="add-switch-uploadfile-modeldata" v-model="UseUploadFile" class="memory-switch" hide-details></v-switch>
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" sm="12" md="6" class="mt-2">
                  <div class="additional-option-group">
                    <div class="d-flex align-center flex-start gap-2 mt-3">
                      <p class="switch-title">Reasoning Effort</p>
                      <v-tooltip location="top" max-width="230px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>Sets the level of internal computational effort the AI will apply to generating a reasoned answer.</span>
                      </v-tooltip>
                    </div>
                    <div class="switch-item">
                      <p class="switch-description">Enable advanced reasoning capabilities</p>
                      <v-switch
                        id="add-switch-EnacleReasoningEffort-modeldata"
                        v-model="UseReasoningEffort"
                        class="memory-switch"
                        hide-details
                      />
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="mt-6">
              <hr>
            </div>

            <!-- JSON Configuration -->
            <div class="form-section mt-4">
              <div class="d-flex justify-space-between align-center">
                <div class="d-flex align-center flex-start gap-2">
                  <img src="@/assets/si_json-duotone.svg" alt="img" width="18" height="18" />
                  <span class="section-title">JSON Configuration</span>
                </div>
                <v-btn @click="showMoreJSONFormat = !showMoreJSONFormat" icon variant="text" size="small">
                  <v-icon :color="showMoreJSONFormat ? '#872612' : '#872612'" size="35">{{ showMoreJSONFormat ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
                </v-btn>
              </div>

              <v-expand-transition>
                <div v-show="showMoreJSONFormat">
                  <div class="mt-2">
                    <h4 class="section-title">System Prompt Format (OpenAI o1+)</h4>
                    <div class="code-example">
                        <pre><code>{{ systemPromptFormatExample }}</code></pre>
                    </div>
                    <ul class="format-notes">
                      <li style="font-size: 13px; color: #171717;">role: Specifies system role for better context</li>
                      <li style="font-size: 13px; color: #171717;">max_completion_tokens: Maximum response length</li>
                      <li style="font-size: 13px; color: #171717;">stream: Enable streaming responses</li>
                    </ul>
                  </div>

                  <!-- JSON Editor -->
                  

                  <div v-if="jsonFormatError" class="error-message">
                    <v-icon size="16" color="error" class="mr-2">mdi-alert-circle</v-icon>
                    <span v-if="jsonFormatError.line">Invalid JSON — Line {{ jsonFormatError.line }}, Col {{ jsonFormatError.col }}</span>
                    <span v-else>Invalid JSON format. Please check your syntax.</span>
                  </div>
                </div>
              </v-expand-transition>
            </div>
          </v-form>

          <div class="json-editor-container" :class="{ error: !!jsonFormatError }">
                    <prism-editor
                      v-model="JSON_Format"
                      :highlight="highlighter"
                      :line-numbers="true"
                      class="json-editor"
                      :class="{ error: !!jsonFormatError }"
                      @drop="onDrop"
                      @dragover="onDragOver"
                    />

                    <!-- JSON Tools -->
                    <div class="json-tools">
                      <button
                        type="button"
                        variant="none"
                        class="json-tool-btn"
                        :disabled="!!jsonFormatError"
                        @click="beautifyJson"
                      >
                        <v-icon size="16" style="color: #ffffff;">mdi-auto-fix</v-icon>
                        <span style="color: #ffffff; font-size: 14px;">Beautify</span>
                      </button>
                      <v-menu>
                        <template v-slot:activator="{ props }">
                          <button
                            type="button"
                            v-bind="props"
                            variant="none"
                            class="json-tool-btn"
                          >
                            <img src="@/assets/ic_round-plus.svg" alt="img" width="16" height="16" />
                            <span style="color: #ffffff; font-size: 14px;">Add Value</span>
                          </button>
                        </template>
                        <v-list class="json-menu">
                          <v-list-item
                            v-for="(item, index) in menuKeyJSON"
                            :key="index"
                            @click="insertJsonValue(item)"
                            @dragstart="onDragStart($event, item.key)"
                            draggable="true"
                            class="json-menu-item draggable-item"
                          >
                            <v-list-item-title>{{
                              item.display
                            }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
          </div>
          <div v-if="jsonFormatError" class="json-error-line">
            <v-icon size="14" color="error">mdi-alert-circle</v-icon>
            <span v-if="jsonFormatError.line">Line {{ jsonFormatError.line }}, Col {{ jsonFormatError.col }} — Invalid JSON</span>
            <span v-else>Invalid JSON format</span>
          </div>
        </div>

        <hr>

        <!-- Dialog Actions -->
        <div class="dialog-actions">
          <button type="button" variant="none" @click="Close" class="model-cancel-button">
            <span style="color: #646464;">Cancel</span>
          </button>
          <button
            type="button"
            id="add-button-save-modeldata"
            variant="none"
            @click="AddModelData"
            :loading="dialog"
            :disabled="currentPlatform === 'Other' && !!jsonFormatError"
            class="models-add-button"
          >
            <span style="color: #ffffff; font-weight: 500;">Add</span>
          </button>
        </div>
      </v-card>
    </v-dialog>

    <!-- Model Edit Dialog -->
    <v-dialog v-model="EditdialogUser" max-width="1000px" persistent class="modern-dialog" >
      <v-card class="dialog-card">
        <div class="header-text-content">
          <h2 class="dialog-header-title"> {{ $t("editnewmodel") }} </h2>
          <p class="dialog-text">{{ "Update model configuration and settings" }}</p>
        </div>
        <div>
          <hr>
        </div>
        
        <!-- Dialog Content -->
        <div class="dialog-body">
          <v-form ref="editForm">
            <!-- Basic Information -->
            <div class="form-section mt-4">
              <div class="d-flex align-center flex-start gap-2">
                <img src="@/assets/streamline-block_basic-ui-link.svg" alt="img" width="18" height="18" />
                <span class="section-title">Basic Information</span>
              </div>
              <v-row class="mt-2" dense>
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Platform">Platform</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The hosting platform or API gateway used to access the AI model.</span>
                    </v-tooltip>
                  </div>
                  <v-autocomplete
                    id="edit-field-platform-modeldata"
                    v-model="currentPlatform"
                    :items="platformOptions"
                    item-title="text"
                    item-value="value"
                    placeholder="Select Platform"
                    persistent-placeholder
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    @update:model-value="changePlatform"
                    class="model-input-control mt-1"
                    clearable
                  >
                  </v-autocomplete>
                </v-col>

                <!-- Model Provider -->
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Model Provider">Model Provider</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The organization or company that created the AI model.</span>
                    </v-tooltip>
                  </div>
                  <v-autocomplete
                    id="edit-field-provider-modeldata"
                    v-model="currentProvider"
                    :items="filteredProviderOptions"
                    item-title="providerName"
                    item-value="providerName"
                    placeholder="Select Model Provider"
                    persistent-placeholder
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    :disabled="isModelProviderAutoFilled"
                    @update:model-value="changeProvider"
                    class="model-input-control mt-1"
                    clearable
                  >
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Model Type">Model Type</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The classification of the model based on its primary function and output capability.</span>
                    </v-tooltip>
                  </div>
                  <v-autocomplete
                    id="edit-field-modeltye-modeldata"
                    v-model="currentModelType"
                    :items="modelTypes"
                    item-title="typeName"
                    item-value="typeValue"
                    placeholder="Model Type"
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    class="model-input-control mt-1"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </div>

            <div class="mt-6">
              <hr>
            </div>

            <!-- Model Details -->
            <div class="form-section mt-4">
              <div class="d-flex align-center flex-start gap-2">
                <img src="@/assets/config.svg" alt="img" width="18" height="18" />
                <span class="section-title">Model Configuration</span>
              </div>
              <v-row class="mt-2" dense>
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Display Name">Display Name</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>Enter the name that will be visible to users in the application interface.</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="edit-field-modeldisplay-modeldata"
                    v-model="currentModelDisplay"
                    placeholder="Display Name"
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    class="model-input-control mt-1"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Model Name">Model Name</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The technical name used by the model provider to refer to this specific AI version.</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="edit-field-modelname-modeldata"
                    v-model="currentModelName"
                    placeholder="Model Name"
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    class="model-input-control mt-1"
                  >
                  </v-text-field>
                </v-col>

                <v-col v-if="showApiVersionField" cols="12" sm="12" md="6" class="mt-2">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="API Version">API Version</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The specific release number or date of the Provider's API.</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="edit-field-APIversion-modeldata"
                    v-model="currentAPIVesion"
                    placeholder="API Version"
                    variant="none"
                    density="comfortable"
                    :rules="rules.required"
                    class="model-input-control mt-1"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="6" class="mt-2">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Max Token">Max Token</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>Set the upper limit on the size of the AI model's response, measured in tokens.</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="edit-field-maxToken-modeldata"
                    v-model="maxToken"
                    placeholder="Max Token"
                    variant="none"
                    density="comfortable"
                    class="model-input-control mt-1 model-number-spinner"
                    type="number"
                    min="0"
                    @keydown="preventNegative"
                  >
                    <template #append-inner>
                      <div class="number-arrows">
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="editMaxToken(1)"
                        >
                          <img src="@/assets/number-up.svg" alt="up" width="10" height="10" />
                        </v-btn>
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="editMaxToken(-1)"
                        >
                          <img src="@/assets/number-down.svg" alt="down" width="10" height="10" />
                        </v-btn>
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <div class="mt-6">
                <hr>
              </div>

              <!-- Additional fields for Other platform -->
              <div v-if="currentPlatform === 'Other'" class="d-flex align-center flex-start gap-2 mt-4">
                <img src="@/assets/icon-park-outline_endpoint-displacement.svg" alt="img" width="18" height="18" />
                <span class="section-title">Endpoint URL</span>
              </div>
              <transition class="mt-1" name="fade-slide" dense>
                <v-row v-if="currentPlatform === 'Other'">
                  <v-col cols="12" sm="12" md="12">
                    <div class="d-flex align-center flex-start gap-2">
                      <label for="Endpoint URL">Endpoint URL</label>
                      <span class="text-error">*</span>
                      <v-tooltip location="top" max-width="400px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>The target URL used to send and receive data from your custom API or external server.</span>
                      </v-tooltip>
                    </div>
                    <v-text-field
                      id="edit-field-endpointURL-modeldata"
                      v-model="EndPointURL"
                      placeholder="Endpoint URL"
                      variant="none"
                      density="comfortable"
                      :rules="rules.required"
                      class="model-input-control mt-1"
                    >
                    </v-text-field>
                  </v-col>

                  <!-- Authentication Header Name -->
                  <v-col cols="12" sm="12" md="6">
                    <div class="d-flex align-center flex-start gap-2">
                      <label for="Authentication Header Name">Authentication Header Name</label>
                      <v-tooltip location="top" max-width="400px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>The header field name where the API key or token is stored for security verification during the request.</span>
                      </v-tooltip>
                    </div>
                    <v-text-field
                      id="edit-field-authen-header-modeldata"
                      v-model="AuthenHeaderName"
                      placeholder="Authentication Header Name"
                      variant="none"
                      density="comfortable"
                      :rules="
                        currentPlatform == 'Other'
                          ? rules.required
                          : rules.notRequired
                      "
                      :disabled="currentPlatform != 'Other'"
                      class="model-input-control mt-1"
                    >
                    </v-text-field>
                  </v-col>

                    <!-- API Key -->
                  <v-col cols="12" sm="12" md="6">
                    <div class="d-flex align-center flex-start gap-2">
                      <label for="API Key">API Key</label>
                      <v-tooltip location="top" max-width="400px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>The secret authentication token required by the service provider to verify your identity and authorize data processing.</span>
                      </v-tooltip>
                    </div>
                    <v-text-field
                      id="edit-field-APIkey-modeldata"
                      v-model="API_Key"
                      placeholder="API Key"
                      variant="none"
                      density="comfortable"
                      :type="Show_API_Key ? 'text' : 'password'"
                      :rules="
                        currentPlatform == 'Other'
                          ? rules.required
                          : rules.notRequired
                      "
                      class="model-input-control mt-1"
                    >
                      <template v-slot:append-inner>
                        <v-btn
                          icon
                          variant="text"
                          size="small"
                          @click="Show_API_Key = !Show_API_Key"
                        >
                          <img :src="Show_API_Key ? eyeOn : eyeOff" alt="img" width="20" height="20" />
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" class="mt-4">
                    <hr>
                  </v-col>
                </v-row>
              </transition>
            </div>

            <!-- Pricing Configuration -->
            <div class="form-section mt-4">
              <div class="d-flex align-center flex-start gap-2">
                <img src="@/assets/money-dollar-circle-line-red.svg" alt="img" width="20" height="20" />
                <span class="section-title">Pricing Configuration</span>
              </div>
              <v-row class="mt-2" v-if="currentModelType !== 'text_to_image'" dense>
                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Input Price">Input Price</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The price per token for sending the prompt data to the model.</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="edit-field-inputprice-modeldata"
                    v-model="CurrentPromptPrice"
                    placeholder="Input Price (USD)"
                    variant="none"
                    density="comfortable"
                    type="number"
                    step="1"
                    class="model-input-control mt-1 model-number-spinner"
                    :rules="rules.requiredNumber"
                    :error-messages="errorMessage.CurrentPromptPrice.message"
                    :error="errorMessage.CurrentPromptPrice.error"
                  >
                    <template #append-inner>
                      <div class="number-arrows">
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="editInputPrice(1)"
                        >
                          <img src="@/assets/number-up.svg" alt="up" width="10" height="10" />
                        </v-btn>
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="editInputPrice(-1)"
                        >
                          <img src="@/assets/number-down.svg" alt="down" width="10" height="10" />
                        </v-btn>
                      </div>
                    </template>
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Output Price">Output Price</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The price per token for the response generated by the model.</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="edit-field-outputprice-modeldata"
                    v-model="CurrentCompletionPrice"
                    placeholder="Output Price (USD)"
                    variant="none"
                    density="comfortable"
                    type="number"
                    step="1"
                    class="model-input-control mt-1 model-number-spinner"
                    :rules="rules.requiredNumber"
                    :error-messages="errorMessage.CurrentCompletionPrice.message" 
                    :error="errorMessage.CurrentCompletionPrice.error"
                  >
                    <template #append-inner>
                      <div class="number-arrows">
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="editOutputPrice(1)"
                        >
                          <img src="@/assets/number-up.svg" alt="up" width="10" height="10" />
                        </v-btn>
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="editOutputPrice(-1)"
                        >
                          <img src="@/assets/number-down.svg" alt="down" width="10" height="10" />
                        </v-btn>
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row class="mt-2" v-else dense>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex align-center flex-start gap-2">
                    <label for="Input Price">Input Price</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>The price per token for sending the prompt data to the model.</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="edit-field-Imageprice-modeldata"
                    v-model="CurrentImagePrice"
                    placeholder="Image Price (USD)"
                    variant="none"
                    density="comfortable"
                    type="number"
                    step="1"
                    class="model-input-control mt-1 model-number-spinner"
                    :rules="rules.requiredNumber"
                  >
                    <template #append-inner>
                      <div class="number-arrows">
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="editCurrentImagePrice(1)"
                        >
                          <img src="@/assets/number-up.svg" alt="up" width="10" height="10" />
                        </v-btn>
                        <v-btn
                          type="button"
                          variant="text"
                          size="x-small"
                          @click.stop="editCurrentImagePrice(-1)"
                        >
                          <img src="@/assets/number-down.svg" alt="down" width="10" height="10" />
                        </v-btn>
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <div class="mt-6">
                <hr>
              </div>
            </div>


            <!-- Image Options -->
            <transition name="fade-slide" class="mt-6">
              <div v-if="currentModelType === 'text_to_image'" class="form-section">
                <div class="d-flex align-center flex-start gap-2">
                  <img src="@/assets/Image option.svg" alt="img" width="18" height="18" />
                  <span class="section-title">Image Generation Options</span>
                </div>
                <v-row class="mt-2" dense>
                  <v-col cols="12" sm="12" md="6">
                    <div class="d-flex align-center flex-start gap-2">
                    <label for="Quality">Quality</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>Controls the visual standard and resolution level for the image output.</span>
                    </v-tooltip>
                  </div>
                    <v-select
                      id="edit-field-Imagequality-modeldata"
                      v-model="currentQuality"
                      :items="imageQualityOptions"
                      item-title="text"
                      item-value="value"
                      placeholderdf="Quality"
                      variant="none"
                      density="comfortable"
                      class="model-input-control mt-1"
                      :rules="rules.required"
                    >
                    </v-select>
                  </v-col>

                  <v-col cols="12" sm="12" md="6">
                    <div class="d-flex align-center flex-start gap-2">
                    <label for="Resolution">Resolution</label>
                    <span class="text-error">*</span>
                    <v-tooltip location="top" max-width="400px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                        />
                      </template>
                      <span>Defines the image's size and clarity and may be subject to system limits.</span>
                    </v-tooltip>
                  </div>
                    <v-select
                      id="edit-field-Resolution-modeldata"
                      v-model="currentResolution"
                      :items="['1024x1024', '1792x1024', '1024x1792']"
                      placeholder="Resolution"
                      variant="none"
                      density="comfortable"
                      class="model-input-control mt-1"
                      :rules="rules.required"
                    >
                    </v-select>
                  </v-col>

                  <v-col cols="12" sm="12" md="6" class="mt-2">
                    <div class="d-flex align-center flex-start gap-2">
                      <label for="ResponseFormat">Response Format</label>
                      <span class="text-error">*</span>
                      <v-tooltip location="top" max-width="230px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>Defines how the model returns image results.</span>
                      </v-tooltip>
                    </div>
                    <v-select
                      id="edit-field-imageFormat-modeldata"
                      v-model="currentResFormat"
                      :items="imageFormatOptions"
                      item-title="text"
                      item-value="value"
                      placeholder="Response Format"
                      variant="none"
                      density="comfortable"
                      :rules="rules.required"
                      class="model-input-control mt-1"
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <div class="mt-6">
                  <hr>
                </div>
              </div>
            </transition>


            <!-- Additional Options -->
            <div class="form-section mt-6">
              <div class="d-flex align-center flex-start gap-2">
                <img src="@/assets/material-symbols_page-info.svg" alt="img" width="18" height="18" />
                <span class="section-title">Additional Options</span>
              </div>
              <v-row>
                <v-col cols="12" sm="12" md="6" class="mt-2">
                  <div class="additional-option-group">
                    <div class="d-flex align-center justify-start gap-2 mt-3" >
                      <p class="switch-title">File Upload Support</p>
                      <v-tooltip location="top" max-width="230px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>Toggle to allow file attachments to be submitted as context to the AI model.</span>
                      </v-tooltip>
                    </div>
                    <div class="d-flex align-center justify-space-between">
                      <p style="color: #171717; font-size: 14px;">Allow file uploads with this model</p>
                      <v-switch id="edit-switch-uploadfile-modeldata" v-model="UseUploadFile" class="memory-switch" hide-details></v-switch>
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" sm="12" md="6" class="mt-2">
                  <div class="additional-option-group">
                    <div class="d-flex align-center flex-start gap-2 mt-3">
                      <p class="switch-title">Reasoning Effort</p>
                      <v-tooltip location="top" max-width="230px">
                        <template v-slot:activator="{ props }">
                          <img
                            v-bind="props"
                            src="@/assets/intent group toolip.svg"
                            alt="info"
                            width="18"
                            height="18"
                          />
                        </template>
                        <span>Sets the level of internal computational effort the AI will apply to generating a reasoned answer.</span>
                      </v-tooltip>
                    </div>
                    <div class="switch-item">
                      <p class="switch-description">Enable advanced reasoning capabilities</p>
                      <v-switch id="edit-switch-EnableReasoningEffort-modeldata" v-model="UseReasoningEffort" class="memory-switch" hide-details></v-switch>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>

            <div class="mt-6">
              <hr>
            </div>

            <!-- JSON Configuration -->
            <div class="form-section mt-6">
              <div class="d-flex justify-space-between align-center">
                <div class="d-flex align-center flex-start gap-2">
                  <img src="@/assets/si_json-duotone.svg" alt="img" width="18" height="18" />
                  <span class="section-title">JSON Configuration</span>
                </div>
                <v-btn @click="showMoreJSONFormat = !showMoreJSONFormat" icon variant="text" size="small">
                  <v-icon :color="showMoreJSONFormat ? '#872612' : '#872612'" size="35">{{ showMoreJSONFormat ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon>
                </v-btn>
              </div>

              <v-expand-transition>
                <div v-show="showMoreJSONFormat">
                  <div class="mt-2">
                    <h4 class="section-title">System Prompt Format (OpenAI o1+)</h4>
                    <div class="code-example">
                      <pre><code>{{ systemPromptFormatExample }}</code></pre>
                    </div>
                    <ul class="format-notes">
                      <li style="font-size: 13px; color: #171717;">
                        role: Specifies system role for better context
                      </li>
                      <li style="font-size: 13px; color: #171717;">
                        max_completion_tokens: Maximum response length
                      </li>
                      <li style="font-size: 13px; color: #171717;">
                        stream: Enable streaming responses
                      </li>
                    </ul>
                  </div>

                  <div v-if="jsonFormatError" class="error-message">
                    <v-icon size="16" color="error" class="mr-2">mdi-alert-circle</v-icon>
                    <span v-if="jsonFormatError.line">Invalid JSON — Line {{ jsonFormatError.line }}, Col {{ jsonFormatError.col }}</span>
                    <span v-else>Invalid JSON format. Please check your syntax.</span>
                  </div>
                </div>
              </v-expand-transition>
            </div>

            <div class="json-editor-container" :class="{ error: !!jsonFormatError }">
              <prism-editor
                id="fleid-jsonFormat-modeldata"
                v-model="JSON_Format"
                :highlight="highlighter"
                :line-numbers="true"
                class="json-editor"
                :class="{ error: !!jsonFormatError }"
                @drop="onDrop"
                @dragover="onDragOver"
               />

                 <!-- JSON Tools -->
                 <div class="json-tools">
                   <button
                     type="button"
                     variant="none"
                     class="json-tool-btn"
                     :disabled="!!jsonFormatError"
                     @click="beautifyJson"
                   >
                     <v-icon size="16" style="color: #ffffff;">mdi-auto-fix</v-icon>
                     <span style="color: #ffffff; font-size: 14px;">Beautify</span>
                   </button>
                   <v-menu>
                     <template v-slot:activator="{ props }">
                       <button
                         type="button"
                         v-bind="props"
                         variant="none"
                         class="json-tool-btn"
                       >
                        <img src="@/assets/ic_round-plus.svg" alt="img" width="16" height="16" />
                        <span style="color: #ffffff; font-size: 14px;">Add Value</span>
                     </button>
                     </template>
                     <v-list class="json-menu">
                       <v-list-item
                         v-for="(item, index) in menuKeyJSON"
                         :key="index"
                         @click="insertJsonValue(item)"
                         @dragstart="onDragStart($event, item.key)"
                         draggable="true"
                         class="json-menu-item draggable-item"
                       >
                         <v-list-item-title>{{
                           item.display
                         }}</v-list-item-title>
                       </v-list-item>
                     </v-list>
                   </v-menu>
                 </div>
              </div>
              <div v-if="jsonFormatError" class="json-error-line">
                <v-icon size="14" color="error">mdi-alert-circle</v-icon>
                <span v-if="jsonFormatError.line">Line {{ jsonFormatError.line }}, Col {{ jsonFormatError.col }} — Invalid JSON</span>
                <span v-else>Invalid JSON format</span>
              </div>
          </v-form>
        </div>

        <hr>

        <!-- Dialog Actions -->
        <div class="dialog-actions">
          <button type="button" variant="none" @click="Close" class="model-cancel-button">
            <span style="color: #646464;">Cancel</span>
          </button>
          <button
            type="button"
            id="edit-button-save-modeldata"
            variant="none"
            @click="UpdateModelData"
            :loading="dialog"
            :disabled="currentPlatform === 'Other' && !!jsonFormatError"
            class="models-add-button"
          >
            <img src="@/assets/mage_save-btn.svg" alt="img" width="20" height="20" />
            <span style="color: #ffffff; font-weight: 400;">{{ $t("save") }}</span>
          </button>
        </div>
      </v-card>
    </v-dialog>

    <!-- Warning Dialog -->
    <v-dialog v-model="showNameRequiredDialog" max-width="460" persistent>
      <v-card class="required-name-dialog" elevation="0">
        <div class="required-name-header">
          <h3 class="required-name-title">Incomplete Information!</h3>
          <button type="button" @click="clearRequiredWarning" class="close-btn">
            <img src="@/assets/codex_cross.svg" alt="close" width="24" height="24" style="margin-left: 12px;" />
          </button>
        </div>
        <div class="required-body">
          <p class="required-name-message">Some required information is needed. Please fill this first.</p>
          <ul v-if="requiredMissingFields.length" class="required-field-list">
            <li v-for="field in requiredMissingFields" :key="field">{{ field }}</li>
          </ul>
        </div>
        <div>
          <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        </div>
        <div class="required-footer">
          <button type="button" class="ok-required-btn" @click="clearRequiredWarning" :id="'button-requiredname-ok'">OK</button>
        </div>
      </v-card>
    </v-dialog>

    <!-- Delete Dialog -->
    <v-dialog v-model="showDeleteDialog" max-width="570" class="delete-dialog-group">
      <v-card class="delete-dialog-card">
        <v-card-title class="card-dialog-title" style="background-color: #FFF2F2;">
          <span class="dialog-title">Delete Confirmation</span>
          <v-btn icon variant="text" density="comfortable" @click="closeDeleteDialog">
            <img src="@/assets/Vector.svg" alt="icon" width="12" height="12">
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6 pb-4 px-4 body-text">
          Do you want to confirm deletion of this Model? This action cannot be undone.
        </v-card-text>
        <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        <v-card-actions class="mt-2 mb-2 justify-end">
          <v-btn class="delete-confirm-btn" :loading="deleting" @click="Delete()">
            <img src="@/assets/heroicons_trash-solid.svg" alt="img" width="17" height="22" class="mr-2">
            <p style="color: #ffffff; font-size: 14px; font-weight: 500;">Delete</p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Replace Before Delete Dialog -->
    <v-dialog v-model="showReplaceDialog" max-width="560" class="delete-dialog-group" persistent>
      <v-card class="delete-dialog-card">
        <!-- Header -->
        <v-card-title class="card-dialog-title" style="background-color: #FFF8E1; min-height: 52px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <v-icon color="#E65100" size="20">mdi-alert-circle-outline</v-icon>
            <span style="font-size: 15px; font-weight: 600; color: #E65100;">Model In Use — Replace Before Deleting</span>
          </div>
          <div style="display: flex; align-items: center; gap: 8px;">
            <v-chip size="x-small" color="orange" variant="tonal" style="font-size: 11px; font-weight: 600; pointer-events: none;">
              Step {{ showReplacePreview ? 2 : 1 }} / 2
            </v-chip>
            <v-btn icon variant="text" density="comfortable" @click="closeDeleteDialog" :disabled="deleting">
              <img src="@/assets/Vector.svg" alt="icon" width="12" height="12">
            </v-btn>
          </div>
        </v-card-title>
        <v-divider></v-divider>

        <!-- Step 1: Select replacement -->
        <template v-if="!showReplacePreview">
          <v-card-text class="pt-4 pb-3 px-4">
            <p class="body-text mb-3">
              The following bot configs are using <strong>{{ currentModelName }}</strong>.
              Select a replacement model before deleting.
            </p>
            <!-- Bot list -->
            <div style="border: 1px solid #FFE0B2; border-radius: 8px; max-height: 160px; overflow-y: auto; background: #FFFDE7; margin-bottom: 16px;">
              <div
                v-for="(bot, idx) in modelInUseBots"
                :key="bot.modelID"
                :style="{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '7px 12px',
                  borderBottom: idx < modelInUseBots.length - 1 ? '1px solid #FFE0B2' : 'none'
                }"
              >
                <v-icon size="15" color="orange-darken-2">mdi-robot</v-icon>
                <span style="font-size: 13px; color: #333;">{{ bot.modelName }}</span>
              </div>
            </div>
            <!-- Replacement select -->
            <v-select
              v-model="replacementModelId"
              :items="allDDLModels"
              item-title="modelDisplay"
              item-value="id"
              label="Select replacement model"
              variant="outlined"
              density="compact"
              no-data-text="No compatible models available (same Platform / Provider / Type)"
              hide-details
              class="model-input-control"
            >
              <template v-slot:item="{ props, item }">
                <v-list-item v-bind="props">
                  <template v-slot:append>
                    <span style="font-size: 11px; color: #888;">{{ item.raw?.modelName }}</span>
                  </template>
                </v-list-item>
              </template>
            </v-select>
          </v-card-text>
          <hr style="border: none; border-top: 1px solid #eee;" />
          <v-card-actions class="pa-3 justify-end" style="gap: 8px;">
            <v-btn variant="text" @click="closeDeleteDialog" :disabled="deleting" style="font-size: 14px; color: #666;">
              Cancel
            </v-btn>
            <v-btn
              :disabled="!replacementModelId"
              @click="showReplacePreview = true"
              variant="outlined"
              style="border-radius: 10px; font-size: 14px; font-weight: 500; min-width: 150px; color: #E65100; border-color: #E65100;"
            >
              Preview Changes
              <v-icon size="16" class="ml-1">mdi-arrow-right</v-icon>
            </v-btn>
          </v-card-actions>
        </template>

        <!-- Step 2: Preview -->
        <template v-else>
          <v-card-text class="pt-4 pb-3 px-4">
            <p class="body-text mb-3" style="color: #555;">Please review the changes before confirming:</p>
            <!-- From → To visualization -->
            <div style="background: #F9F9F9; border: 1px solid #E0E0E0; border-radius: 10px; padding: 14px 14px 12px; margin-bottom: 12px;">
              <div style="display: flex; align-items: stretch; gap: 8px; margin-bottom: 12px;">
                <div style="flex: 1; background: #FFEBEE; border: 1px solid #FFCDD2; border-radius: 8px; padding: 8px 12px;">
                  <div style="font-size: 10px; color: #B71C1C; font-weight: 700; text-transform: uppercase; letter-spacing: 0.6px; margin-bottom: 4px;">Remove</div>
                  <div style="font-size: 13px; font-weight: 600; color: #333; word-break: break-all;">{{ currentModelName }}</div>
                </div>
                <div style="display: flex; align-items: center;">
                  <v-icon color="#9E9E9E" size="22">mdi-arrow-right-bold</v-icon>
                </div>
                <div style="flex: 1; background: #E8F5E9; border: 1px solid #C8E6C9; border-radius: 8px; padding: 8px 12px;">
                  <div style="font-size: 10px; color: #1B5E20; font-weight: 700; text-transform: uppercase; letter-spacing: 0.6px; margin-bottom: 4px;">Replace with</div>
                  <div style="font-size: 13px; font-weight: 600; color: #333; word-break: break-all;">
                    {{ allDDLModels.find(m => m.id === replacementModelId)?.modelDisplay || '' }}
                  </div>
                  <div style="font-size: 11px; color: #888; margin-top: 2px; font-family: monospace;">
                    {{ allDDLModels.find(m => m.id === replacementModelId)?.modelName || '' }}
                  </div>
                </div>
              </div>
              <!-- Affected bots chips -->
              <div style="font-size: 12px; color: #666; font-weight: 600; margin-bottom: 6px;">
                Affected bot configs ({{ modelInUseBots.length }})
              </div>
              <div style="max-height: 90px; overflow-y: auto; display: flex; flex-wrap: wrap; gap: 4px;">
                <v-chip
                  v-for="bot in modelInUseBots"
                  :key="bot.modelID"
                  size="x-small"
                  variant="tonal"
                  color="orange-darken-2"
                  prepend-icon="mdi-robot"
                  style="font-size: 11px;"
                >
                  {{ bot.modelName }}
                </v-chip>
              </div>
            </div>
            <!-- Warning alert -->
            <v-alert
              type="error"
              variant="tonal"
              density="compact"
              icon="mdi-alert-circle-outline"
              style="font-size: 12px; border-radius: 8px;"
            >
              This will update all listed bot configs and permanently delete the original model. This cannot be undone.
            </v-alert>
          </v-card-text>
          <hr style="border: none; border-top: 1px solid #eee;" />
          <v-card-actions class="pa-3 justify-end" style="gap: 8px;">
            <v-btn variant="text" @click="showReplacePreview = false" :disabled="deleting" style="font-size: 14px; color: #666;">
              Back
            </v-btn>
            <v-btn
              class="delete-confirm-btn"
              style="width: auto; min-width: 210px; padding: 0 16px;"
              :loading="deleting"
              @click="ReplaceAndDelete()"
            >
              <img src="@/assets/heroicons_trash-solid.svg" alt="img" width="15" height="15" class="mr-2">
              <p style="color: #ffffff; font-size: 14px; font-weight: 500;">Confirm Replace & Delete</p>
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>

    <!-- Action Not Allowed Fallback Dialog -->
    <v-dialog v-model="showUseModelDeleteDialog" max-width="570" class="delete-dialog-group">
      <v-card class="delete-dialog-card">
        <v-card-title class="card-dialog-title" style="background-color: #FFF2F2;">
          <span class="dialog-title">Action Not Allowed !</span>
          <v-btn icon variant="text" density="comfortable" @click="closeDeleteDialog">
            <img src="@/assets/Vector.svg" alt="icon" width="12" height="12">
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6 pb-4 px-4 body-text">
          {{ useModelDeleteMessage || 'This Model is in use. Please remove any active dependencies before deleting this model.' }}
        </v-card-text>
        <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        <v-card-actions class="mt-2 mb-2 justify-end">
          <v-btn class="delete-confirm-btn" :loading="deleting" @click="closeDeleteDialog()">
            <p style="color: #ffffff; font-size: 14px; font-weight: 500;">OK</p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Loading Overlay -->
    <v-dialog v-model="dialog" persistent width="320">
      <v-card class="loading-card">
        <v-card-text class="text-center py-6">
          <v-progress-circular
            indeterminate
            color="primary"
            size="48"
            class="mb-4"
          ></v-progress-circular>
          <div class="loading-text">Loading...</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
// import checkPermissionTwo from '@/api/function.js';
import LogTrace from "@/api/function.js";
// import Cookies from 'js-cookie';

import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
import textModelTypeIcon from "@/assets/fi-rr-text.svg";
import imageModelTypeIcon from "@/assets/fi-rr-picture.svg";
import eyeOff from "@/assets/iconamoon_eye-off.svg";
import eyeOn from "@/assets/simple-line-icons_eye.svg";

export default {
  name: "MasterData",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  components: {
    PrismEditor,
  },
  mixins: [LogTrace],
  data() {
    return {
      showNameRequiredDialog: false,
      requiredMissingFields: [],
      searchKeyword: "",
      isSearch: false,
      eyeOff,
      eyeOn,
      textModelTypeIcon,
      imageModelTypeIcon,
      showSuccess: false,
      successMessage: "",
      deleting: false,
      _toastTimer: null,
      itemToDelete: null,
      showDeleteDialog: false,
      showUseModelDeleteDialog: false,
      useModelDeleteMessage: "",
      showReplaceDialog: false,
      modelInUseBots: [],
      replacementModelId: null,
      showReplacePreview: false,
      allDDLModels: [],
      isDragOver: false,
      dragCounter: 0,
      listDataModel: [],
      imageFormatOptions: [
        { text: "URL", value: "url" },
        { text: "Base64 JSON", value: "b64_json" },
      ],
      today: null,
      dialog: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      searchTotalTable: 0,
      totalTable: 0,
      itemsPerPage: 10,
      isFirst: true,
      menus: [],
      rules: {
        notRequired: [],
        required: [(value) => !!value || "Required."],
        requiredNumber: [
          (value) => value != 0 || "Required.",
          (value) => !isNaN(value) || "Must be a number.",
        ],
      },
      errorMessage: {
        CurrentPromptPrice: {
          error: false,
          message: ''
        },
        CurrentCompletionPrice: {
          error: false,
          message: ''
        },
        
      },
      images: {
        edit: editImg,
        delete: deleteImg,
      },
      EditdialogUser: false,
      AdddialogUser: false,
      currentModelName: "",
      currentAPIVesion: "",
      maxToken: "",
      currentID: null,
      statusDialog: false,
      statusText: "",
      typeConfirm: "success",
      CurrentPromptPrice: 0,
      CurrentCompletionPrice: 0,
      UseUploadFile: false,
      UseReasoningEffort: false,
      currentModelDisplay: "",
      currentProvider: null,
      currentPlatform: null,
      promptPriceTHB: 0,
      completionPriceTHB: 0,
      sortBy: [],
      sortDesc: [],
      DDProvider: [],
      platformOptions: [
        { text: 'Azure', value: 'Azure' },
        // { text: 'AWS Bedrock', value: 'AWS Bedrock' },
        { text: 'Google Vertex AI', value: 'Google' },
        // { text: 'Grok API (xAI)', value: 'Grok API (xAI)' },
        { text: 'Anthropic Direct', value: 'Anthropic' },
        // { text: 'OpenAI Direct', value: 'OpenAI' },
        // { text: 'Together AI', value: 'Together AI' },
        // { text: 'Fireworks AI', value: 'Fireworks AI' },
        // { text: 'DeepInfra', value: 'DeepInfra' },
        { text: 'Other', value: 'Other' },
      ],
      platformToProviderMap: {
        // 'Grok API (xAI)': 'xAI (Grok)',
        'Anthropic': 'Anthropic',
        // 'OpenAI': 'OpenAI',
        'Google': 'Google',
      },
      currentModelType: null,
      modelTypes: [
        { typeName: "Text-Based", typeId: "1", typeValue: "text_based" },
        { typeName: "Text-to-Image", typeId: "2", typeValue: "text_to_image" },
      ],
      // New data properties for Text-to-image models
      CurrentImagePrice: 0,
      currentQuality: "", // Options: "HD" or "Standard"
      currentResolution: "", // Options: "1024x1024", "1792x1024", "1024x1792"
      currentResFormat: "", // Options: "url" or "b64_json"
      JSON_Format: "",
      systemPromptFormatExample:`{
  "messages":"{messages}"
  "role":"developer"
},
{
  "max_completion_tokens":"{max_completion_tokens}"
  "stream":"{stream}"
}`,
      lineNumbers: true,
      menuKeyJSON: [],
      JSONFormatAddStatus: false,
      JSONFormatEditStatus: false,
      showMoreJSONFormat: false,
      EndPointURL: null,
      API_Key: null,
      AuthenHeaderName: null,
      Show_API_Key: false,
    };
  },
  computed: {
    headers() {
      return [
        { title: "ID", align: "left", sortable: false, width: "60px" },
        {
          title: "Platform",
          align: "left",
          sortable: true,
          value: "platform",
          width: "120px",
        },
        {
          title: this.$t("Provider"),
          align: "left",
          sortable: true,
          value: "provider",
          width: "120px",
        },
        {
          title: this.$t("Display Name"),
          align: "left",
          sortable: true,
          value: "modelDisplay",
          width: "auto",
        },
        {
          title: this.$t("modelName"),
          align: "left",
          sortable: true,
          value: "modelName",
          width: "auto",
        },
        {
          title: "API Version",
          align: "left",
          sortable: true,
          value: "apiVersion",
          width: "120px",
        },
        {
          title: "Model Type",
          align: "center",
          sortable: true,
          value: "modelType",
          width: "150px",
        },
        {
          title: "Price",
          align: "center",
          sortable: false,
          value: "price",
          width: "120px",
        },
        {
          title: this.$t("Actions"),
          align: "center",
          sortable: false,
          width: "100px",
        },
      ];
    },
    isModelProviderAutoFilled() {
      return !!this.platformToProviderMap[this.currentPlatform];
    },
    filteredProviderOptions() {
      if (this.currentPlatform != "Azure") {
        return this.DDProvider;
      }

      return this.DDProvider.filter((provider) => {
        const providerName = this.getProviderName(provider).toLowerCase();
        return providerName != "google" && providerName != "other";
      });
    },
    showApiVersionField() {
      return this.isAnthropicSelection(this.currentPlatform, this.currentProvider);
    },
    imageQualityOptions() {
      const modelName = (this.currentModelName || "").toLowerCase();
      // GPT-Image uses "high" and "low" values
      if (modelName.includes("gpt-image") || modelName.includes("gpt-4o-image")) {
        return [
          { text: "HD", value: "high" },
          { text: "Standard", value: "low" },
        ];
      }
      // DALL-E uses "hd" and "standard" values
      return [
        { text: "HD", value: "hd" },
        { text: "Standard", value: "standard" },
      ];
    },
    jsonFormatError() {
      const s = this.JSON_Format;
      if (!s || s.trim() === '') return null;
      try {
        JSON.parse(s);
        return null;
      } catch (e) {
        const posMatch = e.message.match(/position\s+(\d+)/i);
        if (posMatch) {
          const pos = parseInt(posMatch[1]);
          const before = s.substring(0, pos);
          const lines = before.split('\n');
          return { line: lines.length, col: lines[lines.length - 1].length + 1 };
        }
        const lineColMatch = e.message.match(/line\s+(\d+)\s+column\s+(\d+)/i);
        if (lineColMatch) {
          return { line: parseInt(lineColMatch[1]), col: parseInt(lineColMatch[2]) };
        }
        return { line: null, col: null };
      }
    },
  },
  async mounted() {
    let self = this;
    self.GetDate();
    await self.GetKeyJSON();
    await self.GetProviderData();
  },
  watch: {
    options: {
      handler() {
        this.GetModelData();
      },
      deep: true,
    },
    CurrentPromptPrice: {
      handler: function (newVal, oldVal) {
        let regex = /^\d*\.?\d*$/;
        if (!regex.test(newVal) && newVal != null && newVal != "") {
          this.$nextTick(() => {
            this.CurrentPromptPrice = oldVal;
          });
        }
      },
      deep: true,
    },
    CurrentCompletionPrice: {
      handler: function (newVal, oldVal) {
        let regex = /^\d*\.?\d*$/;
        if (!regex.test(newVal) && newVal != null && newVal != "") {
          this.$nextTick(() => {
            this.CurrentCompletionPrice = oldVal;
          });
        }
      },
      deep: true,
    },
    CurrentImagePrice: {
      handler: function (newVal, oldVal) {
        let regex = /^\d*\.?\d*$/;
        if (!regex.test(newVal) && newVal != null && newVal != "") {
          this.$nextTick(() => {
            this.CurrentImagePrice = oldVal;
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    openDeleteDialog(item) {
      const self = this;
      self.itemToDelete = item;
      self.currentID = item?.id ?? null;
      self.currentModelName = item?.modelName ?? '';
      self.useModelDeleteMessage = '';
      self.showReplacePreview = false;
      self.replacementModelId = null;
      self.modelInUseBots = [];
      self.allDDLModels = [];
      self.dialog = true;
      self.$call.GetModelDataInUse(
        { id: item.id },
        (response) => {
          const status = typeof response?.status === 'string' ? Number(response.status) : response?.status;
          if (status === 0 && response?.data?.isInUse) {
            self.$call.GetDDLModelData(
              (ddlResponse) => {
                self.dialog = false;
                if (ddlResponse.status == 0) {
                  self.allDDLModels = (ddlResponse.data || []).filter(m =>
                    m.id !== item.id &&
                    m.platform === item.platform &&
                    m.provider === item.provider &&
                    m.modelType === item.modelType
                  );
                }
                self.modelInUseBots = response.data.bots || [];
                self.showReplaceDialog = true;
              },
              (err) => {
                self.dialog = false;
                console.error(err);
                self.modelInUseBots = response.data.bots || [];
                self.showReplaceDialog = true;
              }
            );
          } else {
            self.dialog = false;
            self.showDeleteDialog = true;
          }
        },
        (err) => {
          self.dialog = false;
          console.error(err);
          self.showDeleteDialog = true;
        }
      );
    },
    closeDeleteDialog() {
      if (this.deleting) return;
      this.showDeleteDialog = false;
      this.showUseModelDeleteDialog = false;
      this.showReplaceDialog = false;
      this.itemToDelete = null;
      this.useModelDeleteMessage = '';
      this.modelInUseBots = [];
      this.replacementModelId = null;
      this.showReplacePreview = false;
      this.allDDLModels = [];
    },
    isBlank(value) {
      return value === null || value === undefined || String(value).trim() === "";
    },
    isZeroOrInvalidNumber(value) {
      if (this.isBlank(value)) return true;
      const numericValue = Number(value);
      return Number.isNaN(numericValue) || numericValue === 0;
    },
    setRequiredWarning(missingFields = []) {
      this.requiredMissingFields = [...new Set(missingFields)];
      this.showNameRequiredDialog = true;
    },
    clearRequiredWarning() {
      this.requiredMissingFields = [];
      this.showNameRequiredDialog = false;
    },
    getMissingRequiredFields() {
      const missingFields = [];
      const addIfMissing = (label, condition) => {
        if (condition) {
          missingFields.push(label);
        }
      };

      addIfMissing("Platform", this.isBlank(this.currentPlatform));
      addIfMissing("Model Provider", this.isBlank(this.currentProvider));
      addIfMissing("Model Type", this.isBlank(this.currentModelType));
      addIfMissing("Display Name", this.isBlank(this.currentModelDisplay));
      addIfMissing("Model Name", this.isBlank(this.currentModelName));
      addIfMissing("API Version", this.showApiVersionField && this.isBlank(this.currentAPIVesion));

      if (this.currentPlatform == "Other") {
        addIfMissing("Endpoint URL", this.isBlank(this.EndPointURL));
        addIfMissing("Authentication Header Name", this.isBlank(this.AuthenHeaderName));
        addIfMissing("API Key", this.isBlank(this.API_Key));
      }

      if (this.currentModelType === "text_to_image") {
        addIfMissing("Image Price", this.isZeroOrInvalidNumber(this.CurrentImagePrice));
        addIfMissing("Quality", this.isBlank(this.currentQuality));
        addIfMissing("Resolution", this.isBlank(this.currentResolution));
        addIfMissing("Response Format", this.isBlank(this.currentResFormat));
      } else {
        addIfMissing("Input Price", this.isZeroOrInvalidNumber(this.CurrentPromptPrice));
        addIfMissing("Output Price", this.isZeroOrInvalidNumber(this.CurrentCompletionPrice));
      }

      return [...new Set(missingFields)];
    },
    preventNegative(e) {
      if (e.key === '-' || e.key === 'Subtract' || e.key === '.' || e.key === ',') {
        e.preventDefault();
      }
    },
    adjustNumericField(fieldKey, direction) {
      const step = 1;
      const raw = this[fieldKey];
      const current = raw ? Number(raw) : 0;
      if (Number.isNaN(current)) return;

      this[fieldKey] = String(Math.max(0, Math.floor(current + direction * step)));
    },

    adjustPromptPrice(direction) {
      this.adjustNumericField("CurrentPromptPrice", direction);
    },
    adjustMaxToken(direction) {
      this.adjustNumericField("maxToken", direction);
    },
    adjustOutputPrice(direction) {
      this.adjustNumericField("CurrentCompletionPrice", direction);
    },
    adjustCurrentImagePrice(direction) {
      this.adjustNumericField("CurrentImagePrice", direction);
    },
    
    editMaxToken(direction) {
      this.adjustNumericField("maxToken", direction);
    },
    editInputPrice(direction) {
      this.adjustNumericField("CurrentPromptPrice", direction);
    },
    editOutputPrice(direction) {
      this.adjustNumericField("CurrentCompletionPrice", direction);
    },
    editCurrentImagePrice(direction) {
      this.adjustNumericField("CurrentImagePrice", direction);
    },

    onDragOver(event) {
      event.dataTransfer.dropEffect = "copy";
    },

    onDragLeave(event) {
      event.preventDefault();
      this.dragCounter--;
      if (this.dragCounter === 0) {
        this.isDragOver = false;
      }
    },
    CopyText(text) {
      navigator.clipboard.writeText(text);
      this.showPopup();
    },
    insertJsonValue(itemOrText) {
      const propertyName = this.resolveJsonPropertyName(itemOrText);
      const propertyValue = this.resolveJsonPropertyValue(itemOrText);

      if (!propertyName) {
        return;
      }

      const currentJson = this.parseJsonConfigurationForInsert();
      if (currentJson == null) {
        this.$swal.fire({
          icon: "warning",
          title: this.$t("warning"),
          text: "Please fix JSON format before adding a value.",
          showConfirmButton: false,
          timer: 1800,
        });
        return;
      }

      currentJson[propertyName] = propertyValue;
      this.JSON_Format = JSON.stringify(currentJson, null, 2);
    },
    parseJsonConfigurationForInsert() {
      if (this.JSON_Format == null || this.JSON_Format.trim() == "") {
        return {};
      }

      try {
        const parsed = JSON.parse(this.JSON_Format);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
      } catch (error) {
        return null;
      }
    },
    resolveJsonPropertyName(itemOrText) {
      if (itemOrText && typeof itemOrText === "object" && itemOrText.display) {
        return itemOrText.display;
      }

      const keyText = typeof itemOrText === "string" ? itemOrText : itemOrText?.key;
      const matched = String(keyText || "").match(/\{([^{}]+)\}/);
      return matched ? matched[1] : "";
    },
    resolveJsonPropertyValue(itemOrText) {
      const keyText = typeof itemOrText === "string" ? itemOrText : itemOrText?.key;

      try {
        return JSON.parse(keyText);
      } catch (error) {
        return keyText ?? "";
      }
    },
    getProviderIcon(provider) {
      const icons = {
        OpenAI: "mdi-robot",
        Google: "mdi-google",
        Anthropic: "mdi-brain",
        Azure: "mdi-microsoft-azure",
        AWS: "mdi-aws",
        Other: "mdi-cloud",
      };
      return icons[provider] || "mdi-cloud";
    },

    getProviderColor(provider) {
      const colors = {
        OpenAI: "success",
        Google: "warning",
        Anthropic: "info",
        Azure: "primary",
        AWS: "orange",
        Other: "grey",
      };
      return colors[provider] || "grey";
    },

    getModelTypeClass(modelType) {
      return modelType === "text_based" ? "text-based" : "text-to-image";
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    async GetProviderData() {
      let self = this;
      self.dialog = true;
      await self.$call.GetDDLProviderData(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            // console.table(dataResponse.data);
            self.DDProvider = dataResponse.data;
          } else {
            self.DDProvider = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    async GetModelData() {
      try {
        let self = this;
        self.dialog = true;

        let { page, itemsPerPage, sortBy } = self.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === "desc";
        }
        let temp = {
          page: page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          sortDesc: sortOrder,
          sortBy: sortField,
          SearchText: self.searchKeyword != null && self.searchKeyword.trim() !== "" ? self.searchKeyword.trim() : null,
        };
        await self.$call.GetModelData(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.listDataModel = dataResponse.data.data.map(
                (items, index) => ({
                  ...items,
                  key: index + 1,
                  completionPriceUSD: parseFloat(
                    items.completionPriceUSD || 0
                  ).toFixed(6),
                  promptPriceUSD: parseFloat(items.promptPriceUSD || 0).toFixed(
                    6
                  ),
                  imagePriceUSD: parseFloat(items.imagePriceUSD || 0).toFixed(
                    6
                  ),
                })
              );
              self.totalTable = dataResponse.data.total;
              self.searchTotalTable = dataResponse.data.total;
            } else {
              self.listDataModel = [];
              self.totalTable = 0;
              self.searchTotalTable = 0;
            }
            self.dialog = false;
            self.isFirst = false;
          },
          (errorResource) => {
            self.dialog = false;
            if (errorResource.status != 0) {
              console.error(errorResource);
            }
          }
        );
      } catch (error) {
        // this.LogTrace(error, "Apply");
      }
    },

    Search() {
      const self = this;
      const hasSearch = self.searchKeyword != null && self.searchKeyword.trim() !== "";
      self.isSearch = hasSearch;

      if (self.options?.page !== 1) {
        self.options.page = 1;
        return;
      }

      self.GetModelData();
    },

    async AddModelData() {
      try {
        let self = this;
        self.clearRequiredWarning();

        if (self.errorMessage?.CurrentCompletionPrice) {
          self.errorMessage.CurrentCompletionPrice.error = false;
          self.errorMessage.CurrentCompletionPrice.message = "";
        }
        if (self.errorMessage?.CurrentPromptPrice) {
          self.errorMessage.CurrentPromptPrice.error = false;
          self.errorMessage.CurrentPromptPrice.message = "";
        }

        let formValid = true;
        const form = self.$refs?.addForm;
        if (form && typeof form.validate === "function") {
          const res = await form.validate();
          formValid = typeof res === "boolean" ? res : !!res?.valid;
        }

        let pricingValid = true;
        if (self.currentModelType !== "text_to_image") {
          if (self.isZeroOrInvalidNumber(self.CurrentPromptPrice)) {
            pricingValid = false;
            self.errorMessage.CurrentPromptPrice.error = true;
            self.errorMessage.CurrentPromptPrice.message = "Required";
          }
          if (self.isZeroOrInvalidNumber(self.CurrentCompletionPrice)) {
            pricingValid = false;
            self.errorMessage.CurrentCompletionPrice.error = true;
            self.errorMessage.CurrentCompletionPrice.message = "Required";
          }
        }

        const missingRequiredFields = self.getMissingRequiredFields();
        if (!formValid || !pricingValid) {
          self.setRequiredWarning(missingRequiredFields);
          return;
        }
        if (
          self.currentModelName != null &&
          self.currentModelName.trim() != "" &&
          self.isCurrentApiVersionValid() &&
          ((self.currentModelDisplay != null &&
            self.currentModelDisplay.trim() != "" &&
            self.currentPlatform != "Other") ||
            self.currentPlatform == "Other") &&
          self.currentProvider != null &&
          self.currentProvider.trim() != "" &&
          self.currentPlatform != null &&
          self.currentPlatform.trim() != "" &&
          ((self.currentPlatform == "Other" &&
            self.EndPointURL != null &&
            self.EndPointURL.trim() != "") ||
            self.currentPlatform != "Other") &&
          ((self.currentPlatform == "Other" &&
            self.AuthenHeaderName != null &&
            self.AuthenHeaderName.trim() != "" &&
            self.API_Key != null &&
            self.API_Key.trim() != "") ||
            self.currentPlatform != "Other")
        ) {
          if (
            self.currentPlatform == "Other" &&
            self.JSON_Format != null &&
            self.JSON_Format.trim() != "" &&
            !self.isValidJson(self.JSON_Format)
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("_WarningJSONFormat"),
              showConfirmButton: false,
              timer: 1800,
            });
            return;
          }
          if (self.isDuplicateModelDisplay()) {
            self.showDuplicateModelDataWarning();
            return;
          }
          self.dialog = true;
          let temp = {
            ModelName:
              self.currentModelName != null ? self.currentModelName.trim() : "",
            APIVersion: self.getCurrentApiVersionForPayload(),
            ModelDisplay: self.currentModelDisplay.trim(),
            Provider: self.currentProvider != null ? self.currentProvider.trim() : "",
            Platform: self.currentPlatform != null ? self.currentPlatform.trim() : "",
            EndPointURL:
              self.EndPointURL != null ? self.EndPointURL.trim() : "",
            AuthenHeaderName:
              self.AuthenHeaderName != null ? self.AuthenHeaderName.trim() : "",
            API_Key: self.API_Key != null ? self.API_Key.trim() : "",
            UseUploadFile: self.UseUploadFile,
            UseReasoningEffort: self.UseReasoningEffort,
            modelType: self.currentModelType,
            completionPrice: null,
            promptPrice: null,
            imagePriceUSD: null,
            quality: null,
            resolution: null,
            JsonRequest: self.JSON_Format,
            maxToken: self.maxToken == "" ? 4096 : self.maxToken,
            resFormatImage: null,
          };
          if (self.currentModelType === "text_to_image") {
            temp.imagePriceUSD = parseFloat(self.CurrentImagePrice).toFixed(6);
            temp.quality = self.currentQuality;
            temp.resolution = self.currentResolution;
            temp.resFormatImage = self.currentResFormat;
          } else {
            temp.completionPrice = self.CurrentCompletionPrice
            // parseFloat(
            //   self.CurrentCompletionPrice
            // ).toFixed(6)
            //parseFloat(self.CurrentPromptPrice).toFixed(6)
            temp.promptPrice = self.CurrentPromptPrice;
          }
          await self.$call.CreateModelData(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.dialog = false;
                if (dataResponse.data == "Data is duplicate") {
                  self.$swal.fire({
                    icon: "warning",
                    title: self.$t("warning"),
                    text: dataResponse.data,
                    showConfirmButton: false,
                    timer: 1800,
                  });
                } else {
                  self.successMessage = "Model Added Successfully !";
                  self.showSuccess = true;
                  clearTimeout(self._toastTimer);
                  self._toastTimer = setTimeout(() => {
                    self.showSuccess = false;
                  }, 3000);
                  self.AdddialogUser = false;
                  self.totalTable = self.totalTable + 1;
                  self.GetModelData();
                }
              } else {
                self.AdddialogUser = false;
                self.dialog = false;
              }
            },
            (errorResource) => {
              console.log(errorResource);
              self.dialog = false;
              if (errorResource.status != 0) {
                console.error(errorResource);
              }
            }
          );
        } else {
          self.setRequiredWarning(self.getMissingRequiredFields());
        }
      } catch (error) {
      }
    },
    async UpdateModelData() {
      try {
        let self = this;
        self.clearRequiredWarning();

        if (self.errorMessage?.CurrentCompletionPrice) {
          self.errorMessage.CurrentCompletionPrice.error = false;
          self.errorMessage.CurrentCompletionPrice.message = "";
        }
        if (self.errorMessage?.CurrentPromptPrice) {
          self.errorMessage.CurrentPromptPrice.error = false;
          self.errorMessage.CurrentPromptPrice.message = "";
        }

        let formValid = true;
        const form = self.$refs?.editForm;
        if (form && typeof form.validate === "function") {
          const res = await form.validate();
          formValid = typeof res === "boolean" ? res : !!res?.valid;
        }

        let pricingValid = true;
        if (self.currentModelType !== "text_to_image") {
          if (self.isZeroOrInvalidNumber(self.CurrentPromptPrice)) {
            pricingValid = false;
            self.errorMessage.CurrentPromptPrice.error = true;
            self.errorMessage.CurrentPromptPrice.message = "Required";
          }
          if (self.isZeroOrInvalidNumber(self.CurrentCompletionPrice)) {
            pricingValid = false;
            self.errorMessage.CurrentCompletionPrice.error = true;
            self.errorMessage.CurrentCompletionPrice.message = "Required";
          }
        }

        const missingRequiredFields = self.getMissingRequiredFields();
        if (!formValid || !pricingValid) {
          self.setRequiredWarning(missingRequiredFields);
          return;
        }
        if (
          self.currentModelName != null &&
          self.currentModelName.trim() != "" &&
          self.isCurrentApiVersionValid() &&
          ((self.currentModelDisplay != null &&
            self.currentModelDisplay.trim() != "" &&
            self.currentPlatform != "Other") ||
            self.currentPlatform == "Other") &&
          self.currentProvider != null &&
          self.currentProvider.trim() != "" &&
          self.currentPlatform != null &&
          self.currentPlatform.trim() != "" &&
          ((self.currentPlatform == "Other" &&
            self.EndPointURL != null &&
            self.EndPointURL.trim() != "") ||
            self.currentPlatform != "Other") &&
          ((self.currentPlatform == "Other" &&
            self.AuthenHeaderName != null &&
            self.AuthenHeaderName.trim() != "" &&
            self.API_Key != null &&
            self.API_Key.trim() != "") ||
            self.currentPlatform != "Other")
        ) {
          if (
            self.currentPlatform == "Other" &&
            self.JSON_Format != null &&
            self.JSON_Format.trim() != "" &&
            !self.isValidJson(self.JSON_Format)
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("_WarningJSONFormat"),
              showConfirmButton: false,
              timer: 1800,
            });
            return;
          }
          if (!self.isDuplicateModelDisplay(self.currentID)) {
            self.dialog = true;
            let temp = {
              id: self.currentID,
              ModelName:
                self.currentModelName != null
                  ? self.currentModelName.trim()
                  : "",
              APIVersion: self.getCurrentApiVersionForPayload(),
              ModelDisplay: self.currentModelDisplay.trim(),
              Provider: self.currentProvider != null ? self.currentProvider.trim() : "",
              Platform: self.currentPlatform != null ? self.currentPlatform.trim() : "",
              AuthenHeaderName:
                self.AuthenHeaderName != null
                  ? self.AuthenHeaderName.trim()
                  : "",
              EndPointURL:
                self.EndPointURL != null ? self.EndPointURL.trim() : "",
              API_Key: self.API_Key != null ? self.API_Key.trim() : "",
              UseUploadFile: self.UseUploadFile,
              UseReasoningEffort: self.UseReasoningEffort,
              modelType: self.currentModelType,
              completionPrice: null,
              promptPrice: null,
              imagePriceUSD: null,
              quality: null,
              resolution: null,
              JsonRequest: self.JSON_Format,
              maxToken: self.maxToken == "" ? 4096 : self.maxToken,
              resFormatImage: null,
            };

            if (self.currentModelType === "text_to_image") {
              temp.imagePriceUSD = parseFloat(self.CurrentImagePrice).toFixed(
                6
              );
              temp.quality = self.currentQuality;
              temp.resolution = self.currentResolution;
              temp.resFormatImage = self.currentResFormat;
            } else {
              temp.completionPrice = parseFloat(
                self.CurrentCompletionPrice
              ).toFixed(6);
              temp.promptPrice = parseFloat(self.CurrentPromptPrice).toFixed(6);
            }
            await self.$call.UpdateModelData(
              temp,
              (dataResponse) => {
                if (dataResponse.status == 0) {
                  if (dataResponse.data == "Data is duplicate") {
                    self.$swal.fire({
                      icon: "warning",
                      title: self.$t("warning"),
                      text: dataResponse.data,
                      showConfirmButton: false,
                      timer: 1800,
                    });
                  } else {
                    self.successMessage = "Successfully Updated !";
                    self.showSuccess = true;
                    clearTimeout(self._toastTimer);
                    self._toastTimer = setTimeout(() => {
                      self.showSuccess = false;
                    }, 3000);
                    self.EditdialogUser = false;
                    self.dialog = false;
                    self.GetModelData();
                  }
                } else {
                  self.$swal.fire({
                    icon: "error",
                    title: dataResponse.message,
                    showConfirmButton: false,
                    timer: 1800,
                  });
                  self.EditdialogUser = false;
                  self.dialog = false;
                  self.GetModelData();
                }
                self.dialog = false;
                self.isFirst = false;
              },
              (errorResource) => {
                self.dialog = false;
                if (errorResource.status != 0) {
                  console.error(errorResource);
                }
              }
            );
          } else {
            self.showDuplicateModelDataWarning();
          }
        } else {
          self.setRequiredWarning(self.getMissingRequiredFields());
        }
      } catch (error) {
      }
    },
    async DeleteModelData() {
      let self = this;
      if (!self.itemToDelete || self.deleting) return;
      self.deleting = true;
      const deletedId = self.itemToDelete?.id ?? self.currentID;
      let temp = { id: deletedId };
      self.dialog = true;
      self.showDeleteDialog = false;
      self.showUseModelDeleteDialog = false;
      self.showReplaceDialog = false;
      self.$call.DeleteModelData(
        temp,
          (dataResponse) => {
            const apiStatusRaw = dataResponse?.status ?? dataResponse?.Status;
            const apiStatus = typeof apiStatusRaw === "string" ? Number(apiStatusRaw) : apiStatusRaw;
            const apiMessage = dataResponse?.message ?? dataResponse?.Message;

            if (apiStatus === 0) {
              if (deletedId != null) {
                self.listDataModel = (self.listDataModel || []).filter(
                  (x) => x.id !== deletedId
                );
                if (typeof self.searchTotalTable === "number" && self.searchTotalTable > 0) {
                  self.searchTotalTable -= 1;
                }
                if (typeof self.totalTable === "number" && self.totalTable > 0) {
                  self.totalTable -= 1;
                }
              }

              self.successMessage = "Successfully Deleted !";
              self.showSuccess = true;
              clearTimeout(self._toastTimer);
              self._toastTimer = setTimeout(() => {
                self.showSuccess = false;
              }, 3000);
              if ((self.listDataModel || []).length === 0 && self.options?.page > 1) {
                self.options.page = self.options.page - 1;
              } else {
                self.GetModelData();
              }
              if (typeof self.Clear === "function") {
                self.Clear();
              }

              self.itemToDelete = null;
              self.showDeleteDialog = false;
              self.showUseModelDeleteDialog = false;
            } else if (apiStatus === 1) {
              self.showDeleteDialog = false;
              self.useModelDeleteMessage = Response.message || "This model is in use and cannot be deleted.";
              self.showUseModelDeleteDialog = true;
            } else {
              self.showDeleteDialog = false;
              self.showUseModelDeleteDialog = true;
            }
            self.dialog = false;
            self.deleting = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.deleting = false;
            console.error(errorResource);
          }
      );
    },
    async ReplaceAndDelete() {
      const self = this;
      if (!self.replacementModelId || self.deleting) return;
      self.deleting = true;
      self.dialog = true;
      self.showReplaceDialog = false;
      const deletedId = self.itemToDelete?.id ?? self.currentID;
      self.$call.ReplaceAndDeleteModelData(
        { id: deletedId, replacementID: self.replacementModelId },
        (response) => {
          const apiStatus = typeof response?.status === 'string' ? Number(response.status) : response?.status;
          if (apiStatus === 0) {
            self.listDataModel = (self.listDataModel || []).filter(x => x.id !== deletedId);
            if (typeof self.searchTotalTable === 'number' && self.searchTotalTable > 0) self.searchTotalTable -= 1;
            if (typeof self.totalTable === 'number' && self.totalTable > 0) self.totalTable -= 1;
            self.successMessage = 'Model replaced and deleted successfully!';
            self.showSuccess = true;
            clearTimeout(self._toastTimer);
            self._toastTimer = setTimeout(() => { self.showSuccess = false; }, 3000);
            if ((self.listDataModel || []).length === 0 && self.options?.page > 1) {
              self.options.page -= 1;
            } else {
              self.GetModelData();
            }
            self.itemToDelete = null;
          } else {
            self.useModelDeleteMessage = response?.message ?? response?.Message ?? 'Failed to replace model.';
            self.showUseModelDeleteDialog = true;
          }
          self.dialog = false;
          self.deleting = false;
        },
        (err) => {
          self.dialog = false;
          self.deleting = false;
          console.error(err);
        }
      );
    },
    Add() {
      let self = this;
      self.AdddialogUser = true;
      self.clearRequiredWarning();
      self.currentModelName = "";
      self.currentAPIVesion = "";
      self.CurrentCompletionPrice = "";
      self.CurrentPromptPrice = "";
      self.currentModelDisplay = "";
      self.currentProvider = null;
      self.currentPlatform = null;
      self.currentModelType = null;
      self.UseUploadFile = false;
      self.UseReasoningEffort = false;
      // Reset new fields
      self.CurrentImagePrice = 0;
      self.currentQuality = "";
      self.currentResolution = "";
      self.currentResFormat = "";
      self.JSON_Format = `{
  "messages":"{messages}"
}`;
      self.EndPointURL = null;
      self.AuthenHeaderName = null;
      self.API_Key = null;
      self.Show_API_Key = false;
    },
    Edit(item) {
      let self = this;
      self.EditdialogUser = true;
      self.clearRequiredWarning();
      self.currentModelName = item.modelName;
      self.currentAPIVesion = item.apiVersion;
      self.CurrentCompletionPrice = item.completionPriceUSD;
      self.CurrentPromptPrice = item.promptPriceUSD;
      self.currentModelDisplay = item.modelDisplay;
      self.currentProvider = item.provider;
      // Reverse map platform from item or use default
      if (item.platform) {
        self.currentPlatform = item.platform;
      } else {
        // Default mapping for legacy data without platform
        const reverseMap = {};
        for (const [platform, provider] of Object.entries(self.platformToProviderMap)) {
          reverseMap[provider] = platform;
        }
        self.currentPlatform = reverseMap[item.provider] || 'Azure';
      }
      self.currentModelType = item.modelType;
      self.UseUploadFile = item.useUploadFile;
      self.UseReasoningEffort = item.useReasoningEffort;
      self.currentID = item.id;
      self.CurrentImagePrice = item.imagePriceUSD || 0;
      self.currentQuality = item.quality || "";
      self.currentResolution = item.resolution || "";
      self.currentResFormat = item.resFormatImage || "";
      self.JSON_Format = item.jsonRequest || "";
      self.EndPointURL = item.endPointURL || "";
      self.AuthenHeaderName = item.authenHeaderName || "";
      self.API_Key = item.apI_Key || "";
      self.Show_API_Key = false;
      self.maxToken = item.maxToken
    },
    Delete(item) {
      let self = this;
      if (item) {
        self.openDeleteDialog(item);
        return;
      }
      if (!self.itemToDelete || self.deleting) return;
      self.currentID = self.itemToDelete?.id ?? self.currentID;
      self.currentModelName = self.itemToDelete?.modelName ?? self.currentModelName;
      self.DeleteModelData();
    },
    Close() {
      let self = this;

      self.clearRequiredWarning();

      self.errorMessage = {
        CurrentPromptPrice: {
          error: false,
          message: ''
        },
        CurrentCompletionPrice: {
          error: false,
          message: ''
        },
      };

      self.AdddialogUser = false;
      self.EditdialogUser = false;
      self.statusDialog = false;
      self.currentModelName = "";
      self.currentID = null;
      self.CurrentCompletionPrice = "";
      self.CurrentPromptPrice = "";
      self.UseUploadFile = false;
      self.UseReasoningEffort = false;
      self.maxToken = ""
      self.currentPlatform = null;
      self.currentProvider = null;
    },
    CloseStatusDialog() {
      let self = this;
      self.statusDialog = false;
    },
    async GetKeyJSON() {
      let self = this;
      self.dialog = true;
      await self.$call.GetKeyJSON(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.menuKeyJSON = dataResponse.data;
          } else {
            self.menuKeyJSON = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    highlighter(code) {
      return highlight(code, languages.js);
    },
    onDrop(event) {
      event.preventDefault();
      const text = event.dataTransfer.getData("text");
      this.insertJsonValue(text);
    },
    onDragStart(event, text) {
      event.dataTransfer.setData("text", text);
    },
    showPopup() {
      this.showClipboardPopup = true;
      setTimeout(() => {
        this.showClipboardPopup = false;
      }, 2000);
    },
    changePlatform(platform) {
      var self = this;
      // Auto-fill Model Provider if platform has a direct mapping
      if (self.platformToProviderMap[platform]) {
        self.currentProvider = self.platformToProviderMap[platform];
      } else {
        self.currentProvider = null;
      }
      // Handle "Other" platform logic (Endpoint URL section)
      if (platform == "Other") {
        self.currentModelName = null;
        self.currentAPIVesion = null;
      } else {
        self.EndPointURL = null;
        self.AuthenHeaderName = null;
        self.API_Key = null;
      }
      self.syncApiVersionField();
    },
    changeProvider(Provider) {
      var self = this;
      if (self.currentPlatform == "Other") {
        self.currentModelName = null;
        self.currentAPIVesion = null;
      } else {
        self.EndPointURL = null;
        self.AuthenHeaderName = null;
        self.API_Key = null;
      }
      self.syncApiVersionField();
    },
    getProviderName(provider) {
      if (typeof provider == "string") {
        return provider;
      }
      return provider?.providerName || provider?.ProviderName || provider?.value || provider?.text || "";
    },
    isAnthropicName(value) {
      const normalizedValue = String(value || "").trim().toLowerCase();
      return normalizedValue.includes("anthropic") || normalizedValue.includes("claude");
    },
    isAnthropicSelection(platform, provider) {
      return this.isAnthropicName(platform) || this.isAnthropicName(provider);
    },
    isCurrentApiVersionValid() {
      if (!this.showApiVersionField) {
        return true;
      }
      return this.currentAPIVesion != null && this.currentAPIVesion.trim() != "";
    },
    getCurrentApiVersionForPayload() {
      if (!this.showApiVersionField) {
        return null;
      }
      return this.currentAPIVesion != null ? this.currentAPIVesion.trim() : null;
    },
    normalizeDuplicateValue(value) {
      return String(value || "").trim().toLowerCase();
    },
    isDuplicateModelDisplay(ignoreId = null) {
      const currentModelDisplay = this.normalizeDuplicateValue(this.currentModelDisplay);
      if (!currentModelDisplay) {
        return false;
      }

      return this.listDataModel.some((item) => item.id != ignoreId && this.normalizeDuplicateValue(item.modelDisplay) == currentModelDisplay);
    },
    showDuplicateModelDataWarning() {
      this.$swal.fire({
        icon: "warning",
        title: this.$t("warning"),
        text: "Data is duplicate",
        showConfirmButton: false,
        timer: 1800,
      });
    },
    syncApiVersionField() {
      if (!this.showApiVersionField) {
        this.currentAPIVesion = null;
      }
    },
    isValidJson(jsonString) {
      try {
        JSON.parse(jsonString);
        return true;
      } catch (e) {
        return false;
      }
    },
    beautifyJson() {
      try {
        this.JSON_Format = JSON.stringify(JSON.parse(this.JSON_Format), null, 2);
      } catch (e) {
        // no-op: button is disabled when JSON is invalid
      }
    },
  },
};
</script>
<style scoped>
.success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg,#2ABF56,#135928);
  color: #ffffff;
  padding: 10px 24px;
  display: flex;
  align-items: center !important;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 2100;
  width: 50%;
  max-width: 900px;
  min-width: 320px;
  justify-content: center !important;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 110px;
}
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}
.action-divider {
  width: 2px;
  height: 40px;
  background: rgba(0, 0, 0, 0.12);
  border-radius: 1px;
}
.products-header-button {
  display: flex;
  flex-direction: row;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 12px;
  width: auto;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 12px;
}
.products-header-button:hover, .models-add-button:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
}
.model-cancel-button {
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  border: 1px solid #949AA8 !important;
  border-radius: 12px;
  width: 100px;
}
.models-add-button {
  display: flex;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 12px;
  width: 100px;
  justify-content: center !important;
  gap: 8px;
  align-items: center !important;
  padding: 8px;
}
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 700;
  font-size: 16px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
.delete-dialog-group {
  margin-top: -196px;
}
.delete-dialog-card {
  border-radius: 12px !important;
}
.card-dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
}
.dialog-title {
  margin-top: 8px;
  font-size: 16px;
  color: #C30000 !important;
}
.delete-confirm-btn {
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  gap: 16px;
  border-radius: 12px;
  width: 120px;
  background-color: #C30000;
  margin-right: 8px;
}
.price-display {
  padding: 6px 0;
}
:deep(.model-number-spinner input[type="number"]::-webkit-outer-spin-button),
:deep(.model-number-spinner input[type="number"]::-webkit-inner-spin-button) {
  -webkit-appearance: none;
  margin: 0;
}

.number-arrows {
  display: flex;
  flex-direction: column;
  justify-content: center !important;
  align-items: center !important;
}

.model-input-control :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
}
.model-input-control :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 700;
}
.model-input-control :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}
.model-input-control :deep(.v-field) {
  border: 1px solid #c9c9c9 !important;
  border-radius: 12px !important;
  min-height: 48px;
  box-shadow: none !important;
  background: #ffffff !important;
}
.model-input-control :deep(.v-input__details) {
  display: none;
}
.model-input-control :deep(.v-field__input) {
  padding-top: 13px;
}
.memory-switch :deep(.v-switch__track) {
  background: #a6a6a6 !important;
  border: 1px solid #ffffff !important;
  opacity: 1 !important;
  height: 20px !important;
  width: 32px !important;
  border-radius: 22px !important;
}
.memory-switch :deep(.v-switch__thumb) {
  box-shadow: none !important;
  height: 16px !important;
  width: 16px !important;
  margin-left: 4px !important;
  background-color: #FFFFFF !important;
}
.memory-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: #FFFFFF !important;
  border: 1px solid #C32E0E !important;
  
}
.memory-switch :deep(.v-selection-control--dirty .v-switch__thumb) {
  background-color: #C32E0E !important;
  margin-right: 8px !important;
}
.memory-switch :deep(.v-switch__loader) {
  display: none !important;
}
.additional-option-group {
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  background: #ededed !important;
  padding: 0 12px;
  gap: 8px;
}
.v-menu > .v-overlay__content > .v-card, .v-menu > .v-overlay__content > .v-sheet {
  background: #ffffff !important;
  height: 100%;
  border-radius: 12px;
  max-width: 200px;
  overflow: hidden;
}
.required-name-dialog {
  border-radius: 12px !important;
  background: #FFFFFF;
  border: 1px solid #F4D6B8;
}
.required-name-dialog :deep(.v-divider) {
  border-color: #F4D6B8 !important;
}
.required-name-dialog .close-btn {
  color: #B45800;
}
.required-name-dialog .close-btn:hover {
  color: #8C3F00;
}
.required-name-header {
  background: linear-gradient(900deg,#FFF8ED, #FFF0DA);
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.required-name-title {
  font-size: 16px;
  font-weight: 600;
  color: #FFA726;
}
.required-body {
  padding: 16px;
}
.required-name-message {
  font-size: 14px;
  color: #171717;
}
.required-field-list {
  margin: 10px 0 0;
  padding-left: 22px;
  color: #171717;
  font-size: 14px;
  line-height: 1.7;
}
.required-footer {
  display:flex;
  justify-content:flex-end;
  padding: 10px 26px;
}
.ok-required-btn {
  border-radius: 10px;
  font-weight:500;
  font-size:13px;
  color: #ffffff !important;
  width: 80px;
  background: #FFA726;
  padding: 8px;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

/* Add these styles to your component */
/* .model-dialog {
  border-radius: 8px;
}

.dialog-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
} */

::v-deep .v-data-table-server__wrapper th {
  white-space: nowrap;
  vertical-align: middle;
}

::v-deep .v-data-table-server__wrapper__wrapper th span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.rounded-lg {
  border-radius: 8px;
}

.fade-up-enter-active,
.fade-up-leave-active {
  transition: all 0.4s ease;
  max-height: 500px;
  overflow: hidden;
}

.fade-up-enter,
.fade-up-leave-to {
  opacity: 0;
  max-height: 0;
  padding: 0;
  margin: 0;
}

.fade-up-enter-to,
.fade-up-leave {
  opacity: 1;
  max-height: 500px;
}

.price-container {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  /* background-color: rgba(0, 0, 0, 0.03); */
}

.price-content {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.input-section,
.output-section {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.input-section {
  color: var(--v-success-base);
}

.output-section {
  color: var(--v-info-base);
}

.divider {
  color: rgba(0, 0, 0, 0.6);
  margin: 0 4px;
}

.caption {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
}

.image-section {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--v-purple-base);
}
.my-editor {
  background: #2d2d2d;
  color: #ccc;
  min-height: 45px;
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 10px 10px 10px 10px;
}

.draggable-box {
  background-color: #5179ef;
  border-radius: 5px;
  border: 1px solid #5179ef;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
  margin-bottom: 6px;
  padding: 3px;
  padding-left: 12px;
  padding-right: 12px;
  letter-spacing: 1px; /* เพิ่มช่องไฟระหว่างตัวอักษร */
  line-height: 1.6; /* เพิ่มความสูงของบรรทัด */
}

.draggable-box:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  background-color: #45a049;
  border: 1px solid #45a049;
  color: #fff;
}

.areaDrag {
  border: 1px solid #2d2d2d;
  border-radius: 40px 0px 0px 0px;
  padding-top: 3px;
  background: #2d2d2d;
}

#JSONFormat {
  border-radius: 10px 10px 10px 10px;
  display: grid;
  grid-template-rows: auto 1fr;
}

#JSONFormat .v-speed-dial {
  position: absolute;
}

#JSONFormat .v-btn--floating {
  position: relative;
}

.scrollable-content {
  max-height: 250px !important;
  overflow-y: auto !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-end !important;
  padding-right: 150px !important;
}
.my-editor.is-invalid {
  border: 3px solid red;
  border-radius: 4px;
}
.model-data-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 24px;
}

/* Header */
.page-header {
  margin-bottom: 32px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 28px 32px;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 16px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 6px 0;
  line-height: 1.2;
}

.page-subtitle {
  color: #64748b;
  margin: 0;
  font-size: 1rem;
  line-height: 1.4;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 24px;
}

.stats-card {
  background: #f8fafc;
  padding: 16px 24px;
  border-radius: 12px;
  text-align: center;
  border: 1px solid #e2e8f0;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1;
}

.stat-label {
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.date-display {
  display: flex;
  align-items: center;
  color: #64748b;
  font-weight: 500;
}
.main-card {
  border: 1px solid #dcdcdc;
  border-radius: 12px;
  box-shadow: none;
  padding: 8px 16px;
}
.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
}
.search-section {
  width: 300px;
  background: white;
  border: 1px solid #C9C9C9;
  border-radius: 12px;
}
.search-section :deep(.v-field__field) {
  align-items: center;
}
.search-section :deep(input) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 20px;
  min-height: 40px;
  display: flex;
  align-items: center;
  font-size: 13px;
}
.header-text-content {
  padding: 8px 16px !important;
  width: 100%;
}
.dialog-header-title {
  color: #171717;
  font-weight: 600;
}
.dialog-text {
  color: #646464;
  font-size: 13px;
}
hr {
  border: none;
  border-top: 1px solid #c9c9c9;
}

.search-input >>> .v-field {
  border-radius: 12px;
  background: white;
}

.add-button {
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  border-radius: 12px;
  text-transform: none;
  font-weight: 600;
}

.add-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.6);
}

.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid #f1f5f9;
}

.table-row:hover {
  background: #f8fafc;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.table-row td {
  padding: 16px;
  vertical-align: middle;
}

.row-number {
  background: #e2e8f0;
  color: #64748b;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.8125rem;
}

/* Provider Cell */
.provider-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.provider-icon {
  background: #f1f5f9;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.provider-name {
  font-size: 14px;
  color: #171717;
}

/* Model Display */
.model-display {
  display: flex;
  align-items: center;
  gap: 12px;
}

.model-name {
  font-weight: 600;
  color: #1f2937;
}

.model-badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.model-badge.text-based {
  background: #dcfce7;
  color: #166534;
}

.model-badge.text-to-image {
  background: #fef3c7;
  color: #92400e;
}

/* Model Code */
.model-code {
  background: #f1f5f9;
  color: #475569;
  padding: 6px 10px;
  border-radius: 6px;
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.8125rem;
  border: 1px solid #e2e8f0;
}

/* API Version */
.api-version {
  background: #e0e7ff;
  color: #3730a3;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.8125rem;
}

/* Model Type Badge */
.model-type-badge {
  display: flex;
  align-items: center;
  justify-content: center !important;
  padding: 6px;
  gap: 10px;
  border-radius: 20px;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  width: 144px;
}

.model-type-badge.text-based {
  background: rgba(255, 167, 38, 0.16) !important;
  color: #FFA726;
}

.model-type-badge.text-to-image {
  background: rgba(56, 89, 208, 0.16) !important;
  color: #3859D0;
}

.price-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 4px;
}

.price-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 0.8125rem;
}

.price-item.input {
  color: #059669;
}

.price-item.output {
  color: #0ea5e9;
}

.price-item.image {
  color: #7c3aed;
}

.price-unit {
  font-size: 12px;
  color: #171717;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.2px;
}

/* Dialog Styles */
/* .modern-dialog >>> .v-overlay__content {
  border-radius: 20px;
  overflow: hidden;
} */

/* Dialog Header */

/* .dialog-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px 0;
  line-height: 1.3;
}

.dialog-subtitle {
  font-size: 0.9375rem;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
}

.close-button {
  color: #9ca3af !important;
  background: #f9fafb !important;
  border: 1px solid #e5e7eb;
  border-radius: 8px !important;
} */

/* Dialog Content */
.dialog-body {
  padding: 16px;
  max-height: 70vh;
  overflow-y: auto;
}

.section-title {
  font-size: 16px;
  font-weight: 600 !important;
  color: #171717;
}

.section-title.expandable {
  cursor: pointer;
  transition: all 0.2s ease;
  justify-content: space-between;
}

.section-title.expandable:hover {
  color: #3b82f6;
}

.expand-icon {
  transition: transform 0.3s ease;
}

.expand-icon.expanded {
  transform: rotate(180deg);
}

/* Form Grid */
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.form-grid .full-width {
  grid-column: 1 / -1;
}

/* Modern Input */
.modern-input >>> .v-field {
  border-radius: 12px;
  background: #fafbfc;
  transition: all 0.2s ease;
}

.modern-input >>> .v-field__outline {
  color: #d1d5db;
}

.modern-input >>> .v-field--focused .v-field__outline {
  color: #3b82f6;
  border-width: 2px;
}

.modern-input >>> .v-field--focused {
  background: white;
}

.price-suffix {
  font-size: 0.75rem;
  color: #64748b;
  margin-left: 8px;
}

/* Switch Grid */
.switch-grid {
  display: grid;
  gap: 20px;
}

.switch-item {
  display: flex;
  align-items: center !important;
  justify-content: space-between;
}

/* .switch-item:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
} */

.switch-content {
  flex: 1;
}

.switch-title {
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
}

.switch-description {
  font-size: 14px;
  color: #171717;
}

.json-header {
  cursor: pointer;
  margin-bottom: 16px;
}

.json-info-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
}

.json-info-card h4 {
  color: #1f2937;
  font-weight: 600;
  margin-bottom: 12px;
}

.code-example {
  background: #2B2B2C;
  color: #FFFFFF;
  padding: 18px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
  margin-bottom: 16px;
  overflow-x: auto;
}

.code-example pre {
  margin: 0;
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.875rem;
  line-height: 1.5;
}

.format-notes {
  margin: 0;
  padding-left: 20px;
}

.format-notes li {
  margin-bottom: 8px;
  color: #171717;
  font-size: 12px;
}

/* JSON Editor */
.json-editor-container {
  position: relative;
  background: #1e293b;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
}

.json-editor {
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.875rem;
  line-height: 1.6;
  min-height: 200px;
  margin-top: 50px;
}

.json-editor.error {
  border: 2px solid #ef4444;
}

.json-tools {
  position: absolute;
  top: 12px;
  right: 16px;
  display: flex;
  gap: 8px;
}
.json-tool-btn {
  display: flex;
  align-items: center;
  justify-content: center !important;
  border-radius: 12px;
  padding: 8px;
  gap: 6px;
  background: #3859D0;
}
.json-tool-btn:hover {
  opacity: 0.7;
}
.json-tool-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.json-error-line {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px 6px;
  color: #ef4444;
  font-size: 12px;
  font-family: "Monaco", "Consolas", monospace;
}

.json-menu {
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

.json-menu-item {
  padding: 12px 16px;
  transition: all 0.2s ease;
}

.json-menu-item:hover {
  background: #f8fafc;
}

/* Error Message */
.error-message {
  display: flex;
  align-items: center;
  background: #fef2f2;
  color: #dc2626;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #fecaca;
  font-size: 0.875rem;
}

/* Dialog Actions */
.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  padding: 24px 32px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.cancel-btn {
  color: #6b7280 !important;
  font-weight: 500;
}

.save-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%) !important;
  color: white !important;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
  border-radius: 12px !important;
  text-transform: none;
}

.save-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.6);
}

/* Loading Overlay */
.loading-overlay >>> .v-overlay__scrim {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(8px);
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  background: white;
  padding: 32px;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

/* Transitions */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .form-grid {
    grid-template-columns: 1fr;
  }

  .header-content {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .action-bar {
    flex-direction: column;
    gap: 16px;
  }

  .search-section {
    margin-right: 0;
    max-width: none;
  }
}

@media (max-width: 768px) {
  .model-data-container {
    padding: 16px;
  }

  .header-content {
    padding: 20px 24px;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .action-bar {
    padding: 16px 20px;
  }

  .dialog-body {
    padding: 8px 16px;
  }

  .dialog-actions {
    padding: 16px 20px;
  }

  .modern-table >>> thead th,
  .table-row td {
    padding: 12px 8px;
  }
}
.header-icon-container.edit-mode {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

/* Enhanced Form Validation */
.modern-input.error >>> .v-field {
  border-color: #ef4444 !important;
}

.modern-input.error >>> .v-field__outline {
  color: #ef4444 !important;
  border-width: 2px !important;
}

.switch-content {
  flex: 1;
  margin-right: 8px;
}

.switch-title {
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
  font-size: 0.9375rem;
}

/* Enhanced Tooltips */
.v-tooltip >>> .v-overlay__content {
  background: #1f2937 !important;
  color: white !important;
  border-radius: 8px !important;
  padding: 8px 12px !important;
  font-size: 0.8125rem !important;
  max-width: 250px !important;
  text-align: center !important;
}

/* Price Suffix Styling */
.price-suffix {
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 500;
  white-space: nowrap;
}

/* Form Grid Enhancement */
.form-grid .full-width {
  grid-column: 1 / -1;
}

/* JSON Editor Enhanced */
.json-editor-container {
  position: relative;
  background: #1e293b;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  border: 2px solid transparent;
  transition: all 0.2s ease;
}

.json-editor-container:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.json-editor.error {
  background: #1e293b;
}

.json-editor-container.error {
  border-color: #ef4444;
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);
}

/* Loading State for Save Button */
.save-btn.v-btn--loading {
  pointer-events: none;
}

.save-btn .v-btn__loader {
  color: white;
}

/* Enhanced Error Message */
.error-message {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #fef2f2;
  color: #dc2626;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #fecaca;
  font-size: 0.875rem;
  line-height: 1.4;
}

/* Form Section Spacing */
.form-section:last-child {
  margin-bottom: 0;
}

/* Dialog Content Scrollbar */
.dialog-body::-webkit-scrollbar {
  width: 8px;
}

.dialog-body::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.dialog-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.dialog-body::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Enhanced Transitions */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(-8px);
  max-height: 0;
  overflow: hidden;
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(8px);
  max-height: 0;
  overflow: hidden;
}

.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
  max-height: 500px;
}

/* Dialog Responsiveness */
@media (max-width: 768px) {
  .header-info {
    gap: 16px;
  }

  .dialog-title {
    font-size: 1.25rem;
  }

  .dialog-text {
    font-size: 12px;
  }

  .dialog-body {
    padding: 8px 16px;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .dialog-actions {
    padding: 16px;
    flex-direction: column-reverse;
    gap: 8px;
  }

  .save-btn,
  .cancel-btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 640px) {
  .header-icon-container {
    padding: 12px;
  }

  .header-icon-container .v-icon {
    font-size: 20px !important;
  }

  .section-title {
    font-size: 1rem;
  }

  .json-info-card {
    padding: 16px;
  }

  .code-example {
    padding: 12px;
    font-size: 0.8125rem;
  }

  .json-tools {
    position: relative;
    top: auto;
    right: auto;
    margin-top: 12px;
    text-align: center;
  }
}

/* Focus States */
.modern-input >>> .v-field--focused {
  background: white;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

/* Loading Animation */
@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.save-btn.v-btn--loading {
  animation: pulse 1.5s ease-in-out infinite;
}

/* Success State */
.form-section.success {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
}

.form-section.success .section-title {
  color: #171717;
}

.draggable-item {
  cursor: grab;
  transition: all 0.2s ease;
  position: relative;
}

.draggable-item:hover {
  background: #f8fafc;
}

.draggable-item:active {
  cursor: grabbing;
}

.draggable-item >>> .v-list-item__append {
  opacity: 0;
  transition: opacity 0.2s ease;
}

.draggable-item:hover >>> .v-list-item__append {
  opacity: 1;
}

/* Drop Zone Indicator */
.json-editor::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    45deg,
    transparent 25%,
    rgba(59, 130, 246, 0.1) 25%,
    rgba(59, 130, 246, 0.1) 50%,
    transparent 50%,
    transparent 75%,
    rgba(59, 130, 246, 0.1) 75%
  );
  background-size: 20px 20px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.json-editor.drag-over::before {
  opacity: 1;
}

/* Insert Notification */
.insert-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  background: #10b981;
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(16, 185, 129, 0.3);
  z-index: 9999;
  font-weight: 500;
  transform: translateX(0);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.insert-notification.fade-out {
  opacity: 0;
  transform: translateX(100px);
}

/* Enhanced JSON Menu */
.json-menu {
  background: #ffffff !important;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  max-width: 200px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}

.json-menu-item {
  width: 100%;
  box-sizing: border-box;
}

.json-menu-item :deep(.v-list-item-title) {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Scrollbar for JSON Menu */
.json-menu::-webkit-scrollbar {
  width: 6px;
}

.json-menu::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.json-menu::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.json-menu::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.credentials-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .credentials-row {
    grid-template-columns: 1fr;
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .insert-notification {
    top: 10px;
    right: 10px;
    left: 10px;
    font-size: 0.875rem;
  }
}
</style>
